<template>
<div>
  <!-- ローディングモーダル -->
  <dd-loading-modal ref="loadingModalRef"/>
  <div class="modal" v-if="modalDispIf" v-show="modalDispShow"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main new-modal" >
      <!-- カラー設定モーダル -->
      <dd-color-material-list-modal
        ref="ColorMaterialListModalRef"
        :fileData="fileData"
        @changeColorStyleDefault="changeColorStyleDefault"
        @changeColorStyleGrp="changeColorStyleGrp"
      />
      <dd-custom-color-list-modal
        ref="CustomColorListModalRef"
        :fileData="fileData"
        @changeColorIdDefault="changeColorIdDefault"
        @changeColorIdGrp="changeColorIdGrp"
      />
      <div class="title-area" id="modal-moving">
        <h2> {{ getTitle }}</h2>
      </div>
      <div class="data-area">
        <ul class="tab-area">
          <!-- コンバインとセットプランでは基本情報のみ表示 -->
          <li v-for="(tab, index) in filterTabList()" :key="index"
            @click="onClickTab(tab.code)" :class="[isActive === tab.code ? 'active' :'']" class="tab-item" name="t-item">
            {{ tab.label }}
          </li>
        </ul>
        <div class="contents">
          <!-- 基本情報 -->
          <section v-if="isActive === 0" class="tab-detail">
            <ul class="base-info">
              <li v-if="!isEdit && (isCombine || isSetPlan || isSetFix)">
                <span class="label save-check">
                  <input type="checkbox" v-model="saveCheckFlg">{{ getTypeName }}として保存する
                </span>
              </li>
              <li v-if="isPlan">
                <span class="label">物件名
                  <font color="red">(必須)</font>
                </span>
                <input type="text" class="bs-input" v-if="!isEdit" v-model="planPropertyName" placeholder="物件名" :disabled="isAddSetOrComb">
                <input type="text" class="bs-input" v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planPropertyName" placeholder="物件名">
              </li>
              <li>
                <span class="label">{{ getSaveName }}
                  <font color="red">(必須)</font>
                  <span class="tooltip">
                    <img :src="imgQMark" width="15px" height="auto"/>
                    <span>プランデータの保存名となります。
                    <br>
                    各図面、見積書に記載されます。</span>
                  </span>
                </span>
                <input type="text" class="bs-input" v-if="!isEdit" v-model="name" :placeholder="getTypeName + '名'" :disabled="isAddSetOrComb">
                <input type="text" class="bs-input" v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.fileName" :placeholder="getTypeName + '名'">
              </li>
              <li>
                <span class="label">製品シリーズ
                  <span class="tooltip">
                    <img :src="imgQMark" width="15px" height="auto"/>
                    <span>シリーズを分け、プランを管理しやすくする機能です。
                    <br>
                    本契約後、ご利用いただけます。</span>
                  </span>
                </span>
                <div>{{series.seriesName}}</div>
              </li>
              <li>
                <span class="label">カテゴリー</span>
                <select  v-if="!isEdit" v-model="categoryNo" :disabled="isAddSetOrComb">
                  <option v-for="(category, index) in setCategoryList" :key="index" :value="category.categoryNo">{{ category.categoryName }}</option>
                </select>
                <select v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.categoryNo">
                  <option v-for="(category, index) in setCategoryList" :key="index" :value="category.categoryNo">{{ category.categoryName }}</option>
                </select>
              </li>
              <!-- <li> -->
              <li v-if="!isPlan">
                <span class="label">製品品番
                  <span class="tooltip">
                    <img :src="imgQMark" width="15px" height="auto"/>
                    <span>
                    プランデータの保存品番です。
                    <br>
                    重複した番号は使用できません。
                    <br>
                    図面や見積書等の自動生成出力物に記載されます。
                    </span>
                  </span>
                </span>
                <input v-if="!isEdit" v-model="fileCode" type="text" class="bs-input" placeholder="製品品番" :disabled="isAddSetOrComb">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.fileCode" class="bs-input" placeholder="製品品番">
              </li>
              <li v-if="isPlan && !dispTrialUserTools">
                <span class="label">数量</span>
                <input type="number" class="bs-input" v-if="!isEdit" v-model="planCount" placeholder="数量" :disabled="isAddSetOrComb">
                <input type="number" class="bs-input" v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planCount" placeholder="数量">
              </li>
            <!--
              <li v-if="isPlan && !dispTrialUserTools">
                <span class="label">部屋の幅x高さ</span>
                <input type="number" class="half" v-if="!isEdit" v-model="planRoomW" placeholder="幅" :disabled="isAddSetOrComb">
                <input type="number" class="half" v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planRoomW" placeholder="幅">
                <input type="number" class="half" v-if="!isEdit" v-model="planRoomH" placeholder="高さ" :disabled="isAddSetOrComb">
                <input type="number" class="half" v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planRoomH" placeholder="高さ">
              </li>
              <li v-if="isPlan && !dispTrialUserTools">
                <span class="label">収納スペース壁設定 (左)</span>
                <div class="div-radio">
                  <input type="radio" v-if="!isEdit" id="wallL0" name="wallL_type" :value="0" v-model="planWallL"/>
                  <input type="radio" v-if="isEdit" id="wallL0" name="wallL_type" :value="0" v-model="fileData.planDataModel.planWallL"/>
                  <label for="wallL0">オープン</label>
                  <input type="radio" v-if="!isEdit" id="wallL1" name="wallL_type" :value="1" v-model="planWallL"/>
                  <input type="radio" v-if="isEdit" id="wallL1" name="wallL_type" :value="1" v-model="fileData.planDataModel.planWallL"/>
                  <label for="wallL1">入隅</label>
                  <input type="radio" v-if="!isEdit" id="wallL2" name="wallL_type" :value="2" v-model="planWallL"/>
                  <input type="radio" v-if="isEdit" id="wallL2" name="wallL_type" :value="2" v-model="fileData.planDataModel.planWallL"/>
                  <label for="wallL2">出隅</label>
                </div>
              </li>
              <li v-if="isPlan && !dispTrialUserTools">
                <span class="label">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;(右)</span>
                <div class="div-radio">
                  <input type="radio" v-if="!isEdit" id="wallR0" name="wallR_type" :value="0" v-model="planWallR"/>
                  <input type="radio" v-if="isEdit" id="wallR0" name="wallR_type" :value="0" v-model="fileData.planDataModel.planWallR"/>
                  <label for="wallR0">オープン</label>
                  <input type="radio" v-if="!isEdit" id="wallR1" name="wallR_type" :value="1" v-model="planWallR"/>
                  <input type="radio" v-if="isEdit" id="wallR1" name="wallR_type" :value="1" v-model="fileData.planDataModel.planWallR"/>
                  <label for="wallR1">入隅</label>
                  <input type="radio" v-if="!isEdit" id="wallR2" name="wallR_type" :value="2" v-model="planWallR"/>
                  <input type="radio" v-if="isEdit" id="wallR2" name="wallR_type" :value="2" v-model="fileData.planDataModel.planWallR"/>
                  <label for="wallR2">出隅</label>
                </div>
              </li>
            -->
              <li v-if="isPlan && !dispTrialUserTools">
                <span class="label desp">営業コメント</span>
                <textarea v-if="!isEdit" v-model="planSalesComment" rows="10" class="bs-input" placeholder="コメント" :disabled="isAddSetOrComb"></textarea>
                <textarea v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planSalesComment" rows="10" class="bs-input" placeholder="コメント"></textarea>
              </li>
              <li>
                <span class="label desp">説明
                  <span class="tooltip">
                    <img :src="imgQMark" width="15px" height="auto"/>
                    <span>保存されたプランの呼び出し画面に表示される説明です。
                    </span>
                  </span>
                </span>
                <textarea v-if="!isEdit" v-model="fileCaption" rows="10" class="bs-input" placeholder="説明文" :disabled="isAddSetOrComb"></textarea>
                <textarea v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.fileCaption" rows="10" class="bs-input" placeholder="説明文"></textarea>
                <!-- <p class="error_message error_ds" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['basicFileDataForm.fileCaption'] }}</p> -->
              </li>
            </ul>
          </section>
          <!-- カラー設定 -->
          <section v-if="isActive === 1" class="tab-detail-color-style">
            <ul>
              <li>
                <span class="label">カラースタイル名</span>
                <div class="div-color-style">{{colorStyleConf.colorStyleConfigName}}</div>
                <span class="label-color-style">補足情報</span>
              </li>
              <li>
                <span class="label">{{colorStyleNameList[0]}}</span>
                <!-- 新規 -->
                <div v-if="!isEdit">
                  <button class="main_btn" @click="showCMListModalFromDef(colorStyleDefault)">変更</button>
                  {{ colorMaterialList.find(c => c.colorMaterialId === colorStyleDefault).colorMaterialName}}
                </div>
                <input v-if="!isEdit" class="sm-input" v-model="colorStyleDefaultStr">
                <div class="div-custom" v-if="!isEdit">
                  <button class="main_btn" v-if="colorMaterialList.find(c => c.colorMaterialId === colorStyleDefault).colorMaterialCustomFlg"
                    @click="showCustomListModalFromDef(colorStyleDefaultColor, colorStyleDefault)">カスタム</button>
                </div>
                <!-- 編集中 -->
                <div v-if="isEdit && fileData && Object.keys(fileData).length > 0 && fileData.colorStyleDataModelList && fileData.colorStyleDataModelList.length > 0">
                  <button class="main_btn" @click="showCMListModalFromDef(fileData.colorStyleDataModelList[0].colorStyleDefault)">変更</button>
                    {{ colorMaterialList.find(c => c.colorMaterialId === fileData.colorStyleDataModelList[0].colorStyleDefault).colorMaterialName}}
                </div>
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0 && fileData.colorStyleDataModelList && fileData.colorStyleDataModelList.length > 0" class="sm-input" v-model="fileData.colorStyleDataModelList[0].colorStyleDefaultStr">
                <div class="div-custom" v-if="isEdit && fileData && Object.keys(fileData).length > 0 && fileData.colorStyleDataModelList && fileData.colorStyleDataModelList.length > 0">
                  <button class="main_btn" v-if="colorMaterialList.find(c => c.colorMaterialId === fileData.colorStyleDataModelList[0].colorStyleDefault).colorMaterialCustomFlg"
                    @click="showCustomListModalFromDef(fileData.colorStyleDataModelList[0].colorStyleDefaultColor,
                    fileData.colorStyleDataModelList[0].colorStyleDefault)">カスタム</button>
                </div>
              </li>
              <li v-for="(num, index) in 10" :key="index">
                <section v-if="colorStyleNameList[num] != null">
                  <span class="label">{{ colorStyleNameList[num] }}</span>
                  <!-- 新規 -->
                  <div v-if="!isEdit && getColorMaterial(num, isEdit)">
                    <button class="main_btn" @click="showCMListModalFromGrp(colorStyleGrp[num], colorStyleTypeList[num], num)">変更</button>
                    {{ getColorMaterial(num, isEdit).colorMaterialName }}
                  </div>
                  <input v-if="!isEdit && getColorMaterial(num, isEdit)"
                    class="sm-input" v-model="colorStyleGrpStr[num]">
                  <div class="div-custom" v-if="!isEdit && getColorMaterial(num, isEdit)">
                    <button class="main_btn" v-if="getColorMaterial(num, isEdit).colorMaterialCustomFlg"
                      @click="showCustomListModalFromGrp(colorStyleGrpColor[num], colorStyleGrp[num], colorStyleTypeList[num], num)">カスタム</button>
                  </div>
                  <!-- 編集中 -->
                  <div v-if="isEdit && getColorMaterial(num, isEdit)">
                    <button class="main_btn" @click="showCMListModalFromGrp(uColorStyleGrp[num], colorStyleTypeList[num], num)">変更</button>
                    {{ getColorMaterial(num, isEdit).colorMaterialName }}
                  </div>
                  <input v-if="isEdit && fileData && Object.keys(fileData).length > 0 && fileData.colorStyleDataModelList && fileData.colorStyleDataModelList.length > 0 &&
                    getColorMaterial(num, isEdit)" class="sm-input" v-model="uColorStyleGrpStr[num]"/>
                  <div class="div-custom" v-if="isEdit && fileData && Object.keys(fileData).length > 0 && fileData.colorStyleDataModelList && fileData.colorStyleDataModelList.length > 0 &&
                    getColorMaterial(num, isEdit)">
                    <button class="main_btn" v-if="getColorMaterial(num, isEdit).colorMaterialCustomFlg"
                        @click="showCustomListModalFromGrp(uColorStyleGrpColor[num], uColorStyleGrp[num], colorStyleTypeList[num], num)">カスタム</button>
                  </div>
                </section>
              </li>
            </ul>
          </section>
          <!-- プラン情報１ -->
          <section v-if="isActive === 2" class="tab-detail">
            <ul>
              <li>
                <span class="label">得意先選択
                  <span class="tooltip">
                    <img :src="imgQMark" width="15px" height="auto"/>
                    <span>保存済みの「得意先・納品先」情報を選択します。
                    <br>
                    見積書に記載されます。</span>
                  </span>
                </span>
                <select  v-if="!isEdit" v-model="businessId" @change="changeBusiness">
                  <option value=""></option>
                  <option v-for="(business, index) in businessList" :key="index" :value="business.businessId">{{ business.businessName }}</option>
                </select>
                <select v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planBusinessId" @change="changeBusiness">
                  <option value=""></option>
                  <option v-for="(business, index) in businessList" :key="index" :value="business.businessId">{{ business.businessName }}</option>
                </select>
              </li>
              <li>
                <span class="label"> </span>
                <button type="button" class="main_btn" @click="$emit('showNewBusinessModal', false)">新規得意先登録</button>
                <button type="button" class="main_btn" @click="$emit('showEditBusinessModal', selectedBusiness)">得意先情報編集</button>
              </li>
              <li>
                <span class="label">納品先名
                  <span class="tooltip">
                    <img :src="imgQMark" width="15px" height="auto"/>
                    <span>見積書の「納品先」に記載されます。</span>
                  </span>
                </span>
                <input v-if="!isEdit" v-model="planDeliveryName" type="text" class="bs-input deli" placeholder="納品先名">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryName" class="bs-input deli" placeholder="納品先名">
              </li>
              <li v-if="!isOrder">
                <span class="label">納品先
                  <span class="tooltip">
                    <img :src="imgQMark" width="15px" height="auto"/>
                    <span>見積書の「納品先住所」に記載されます。</span>
                  </span>
                </span>
                <input v-if="!isEdit" v-model="planDeliveryCountry" type="text" class="bs-input deli" placeholder="国">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryCountry" class="bs-input deli" placeholder="国">
              </li>
              <li v-if="!isOrder">
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryPostcd" type="text" class="bs-input deli" placeholder="郵便番号">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryPostcd" class="bs-input deli" placeholder="郵便番号">
              </li>
              <li v-else>
                <span class="label">納品先
                  <span class="tooltip">
                    <img :src="imgQMark" width="15px" height="auto"/>
                    <span>見積書の「納品先住所」に記載されます。</span>
                  </span>
                </span>
                <input v-if="!isEdit" v-model="planDeliveryPostcd" type="text" class="bs-input deli" placeholder="郵便番号">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryPostcd" class="bs-input deli" placeholder="郵便番号">
              </li>
              <li>
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryState" type="text" class="bs-input deli" placeholder="都道府県">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryState" class="bs-input deli" placeholder="都道府県">
              </li>
              <li>
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryCity" type="text" class="bs-input deli" placeholder="市区町村">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryCity" class="bs-input deli" placeholder="市区町村">
              </li>
              <li>
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryStreet" type="text" class="bs-input deli" placeholder="住所/番地">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryStreet" class="bs-input deli" placeholder="住所/番地">
              </li>
              <li>
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryBuilding" type="text" class="bs-input deli" placeholder="建物名">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryBuilding" class="bs-input deli" placeholder="建物名">
              </li>
              <li>
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryFloor" type="text" class="bs-input deli" placeholder="階、部屋No.">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryFloor" class="bs-input deli" placeholder="階、部屋No.">
              </li>
              <li>
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryTel" type="text" class="bs-input deli" placeholder="電話番号">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryTel" class="bs-input deli" placeholder="電話番号">
              </li>
              <li>
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryFax" type="text" class="bs-input deli" placeholder="FAX番号">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryFax" class="bs-input deli" placeholder="FAX番号">
              </li>
              <li>
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryLastName" type="text" class="bs-input half deli" placeholder="担当者(姓)">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliverryLastName" class="bs-input half deli" placeholder="担当者(姓)">
                <input v-if="!isEdit" v-model="planDeliveryFirstName" type="text" class="bs-input half deli" placeholder="担当者(名)">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliverryFirstName" class="bs-input half deli" placeholder="担当者(名)">
              </li>
              <li>
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryLastNameKana" type="text" class="bs-input half deli" placeholder="担当者(セイ)">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliverryLastNameKana" class="bs-input half deli" placeholder="担当者(セイ)">
                <input v-if="!isEdit" v-model="planDeliveryFirstNameKana" type="text" class="bs-input half deli" placeholder="担当者(メイ)">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliverryFirstNameKana" class="bs-input half deli" placeholder="担当者(メイ)">
              </li>
              <li v-if="!isOrder">
                <span class="label"></span>
                <input v-if="!isEdit" v-model="planDeliveryNotice" type="text" class="bs-input half deli" placeholder="連絡事項">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliverryNotice" class="bs-input" placeholder="説明事項">
              </li>
              <!-- <li v-if="isOrder">
                <span class="label">販売先</span>
                <select v-model="planLayer">
                  <option v-for="(layer,index) in layerList" :key="index" :value="layer">{{layer.planLayerName}}</option>
                </select>
              </li> -->
              <li v-if="isOrder">
                <span class="label">養生の必要性</span>
                <select v-model="planEcHealthCare">
                  <option v-for="(type,index) in healthCareList" :key="index" :value="type.code">{{type.label}}</option>
                </select>
              </li>
              <li>
                <span class="label">納品予定日
                  <span class="tooltip">
                    <img :src="imgQMark" width="15px" height="auto"/>
                    <span>見積書の「納品日」に記載されます。</span>
                  </span>
                </span>
                <input v-if="!isEdit" v-model="planEcInfoDeliPref1" type="date" class="bs-input" placeholder="納品予定日">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planEcModel.ecInfoDeliPref1" type="date" class="bs-input" placeholder="納品予定日">
              </li>
              <li>
                <ul class="select-time">
                  <li>
                    <span class="label"></span>
                    <input type="radio" id="time0" name="target_time" :value="0" v-model="selectTime"/>
                    <label for="time0">指定なし</label>
                  </li>
                  <li>
                    <span class="label"></span>
                    <input type="radio" id="time1" name="target_time" :value="1" v-model="selectTime"/>
                    <label for="time1">午前中(8:00～12:00)</label>
                  </li>
                  <li>
                    <span class="label"></span>
                    <input type="radio" id="time2" name="target_time" :value="2" v-model="selectTime"/>
                    <label for="time2">午後(12:00～15:00)</label>
                  </li>
                  <li>
                    <span class="label"></span>
                    <input type="radio" id="time3" name="target_time" :value="3" v-model="selectTime"/>
                    <label for="time2">指定する</label>
                    <div class="input_div" v-if="selectTime===3">
                      <input v-model="textDateTime" type="text" class="bs-input" placeholder="16:00">
                    </div>
                  </li>
                </ul>
                <div></div>
              </li>
              <li v-if="!isOrder">
                <span class="label">組立設置希望日 第一希望日
                </span>
                <input v-if="!isEdit" v-model="planEcInfoBtPref1" type="date" class="bs-input" placeholder="組立設置希望日 第一希望日">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planEcModel.ecInfoBtPref1" type="date" class="bs-input" placeholder="組立設置希望日 第一希望日">
              </li>
              <li v-if="!isOrder">
                <span class="label">組立設置希望日 第二希望日
                </span>
                <input v-if="!isEdit" v-model="planEcInfoBtPref2" type="date" class="bs-input" placeholder="組立設置希望日 第二希望日">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planEcModel.ecInfoBtPref2" type="date" class="bs-input" placeholder="組立設置希望日 第二希望日">
              </li>
              <li v-if="!isOrder">
                <span class="label">組立設置希望日 第三希望日
                </span>
                <input v-if="!isEdit" v-model="planEcInfoBtPref3" type="date" class="bs-input" placeholder="組立設置希望日 第三希望日">
                <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planEcModel.ecInfoBtPref3" type="date" class="bs-input" placeholder="組立設置希望日 第三希望日">
              </li>
            </ul>
          </section>
          <!-- プラン情報２ -->
          <section v-if="isActive === 3" class="tab-detail">
            <div class="plan-data2">
              <div class="input-area left">
                <ul>
                  <li>
                    <span class="label">材料管理費率</span>
                    <!-- <input v-if="!isEdit" v-model="planMaterialMagProb" type="number" class="bs-input" placeholder="材料管理費率"> -->
                    <input v-if="!isEdit" v-model="planMaterialMagProb" type="number" class="bs-input-price" placeholder="材料管理費率">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planMaterialMagProb" type="number" class="bs-input" placeholder="材料管理費率"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planMaterialMagProb" type="number" class="bs-input-price" placeholder="材料管理費率">
                    %
                  </li>
                  <li>
                    <span class="label">加工費 分レート</span>
                    <!-- <input v-if="!isEdit" v-model="planProcessCostMin" type="number" class="bs-input" placeholder="加工費 分レート"> -->
                    <input v-if="!isEdit" v-model="planProcessCostMin" type="number" class="bs-input-price" placeholder="加工費 分レート">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProcessCostMin" type="number" class="bs-input" placeholder="加工費 分レート"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProcessCostMin" type="number" class="bs-input-price" placeholder="加工費 分レート">
                    円/分
                  </li>
                  <li>
                    <span class="label">生産管理費率</span>
                    <!-- <input v-if="!isEdit" v-model="planProcessMagProb" type="number" class="bs-input" placeholder="生産管理費率"> -->
                    <input v-if="!isEdit" v-model="planProcessMagProb" type="number" class="bs-input-price" placeholder="生産管理費率">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProcessMagProb" type="number" class="bs-input" placeholder="生産管理費率"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProcessMagProb" type="number" class="bs-input-price" placeholder="生産管理費率">
                    %
                  </li>
                  <li>
                    <span class="label">工場利益率</span>
                    <!-- <input v-if="!isEdit" v-model="planProcessProfitProb" type="number" class="bs-input" placeholder="工場利益率"> -->
                    <input v-if="!isEdit" v-model="planProcessProfitProb" type="number" class="bs-input-price" placeholder="工場利益率">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProcessProfitProb" type="number" class="bs-input" placeholder="工場利益率"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProcessProfitProb" type="number" class="bs-input-price" placeholder="工場利益率">
                    %
                  </li>
                  <li>
                    <span class="label">輸送賃</span>
                    <!-- <input v-if="!isEdit" v-model="planFacttransCost" type="number" class="bs-input" placeholder="輸送賃"> -->
                    <input v-if="!isEdit" v-model="planFacttransCost" type="number" class="bs-input-price" placeholder="輸送賃">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planFacttransCost" type="number" class="bs-input" placeholder="輸送賃"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planFacttransCost" type="number" class="bs-input-price" placeholder="輸送賃">
                    円
                  </li>
                  <!-- add DCD-464 20230912 start -->
                  <li>
                    <span class="label">施工人件費単価</span>
                    <!-- <input v-if="!isEdit" v-model="planExecutionCostPerson" type="number" class="bs-input" placeholder="施工人件費単価"> -->
                    <input v-if="!isEdit" v-model="planExecutionCostPerson" type="number" class="bs-input-price" placeholder="施工人件費単価">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planExecutionCostPerson" type="number" class="bs-input" placeholder="施工人件費単価"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planExecutionCostPerson" type="number" class="bs-input-price" placeholder="施工人件費単価">
                    円/分
                  </li>
                  <li>
                    <span class="label">施工駐車場単価</span>
                    <!-- <input v-if="!isEdit" v-model="planExecutionCostCar" type="number" class="bs-input" placeholder="施工駐車場単価"> -->
                    <input v-if="!isEdit" v-model="planExecutionCostCar" type="number" class="bs-input-price" placeholder="施工駐車場単価">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planExecutionCostCar" type="number" class="bs-input" placeholder="施工駐車場単価"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planExecutionCostCar" type="number" class="bs-input-price" placeholder="施工駐車場単価">
                    円/分
                  </li>
                  <li>
                    <span class="label">施工費最低保証金額</span>
                    <!-- <input v-if="!isEdit" v-model="planExecutionCostMin" type="number" class="bs-input" placeholder="施工費最低保証金額"> -->
                    <input v-if="!isEdit" v-model="planExecutionCostMin" type="number" class="bs-input-price" placeholder="施工費最低保証金額">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planExecutionCostMin" type="number" class="bs-input" placeholder="施工費最低保証金額"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planExecutionCostMin" type="number" class="bs-input-price" placeholder="施工費最低保証金額">
                    円
                  </li>
                  <li>
                    <span class="label">搬入人件費単価</span>
                    <!-- <input v-if="!isEdit" v-model="planMobilizationCostPerson" type="number" class="bs-input" placeholder="搬入人件費単価"> -->
                    <input v-if="!isEdit" v-model="planMobilizationCostPerson" type="number" class="bs-input-price" placeholder="搬入人件費単価">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planMobilizationCostPerson" type="number" class="bs-input" placeholder="搬入人件費単価"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planMobilizationCostPerson" type="number" class="bs-input-price" placeholder="搬入人件費単価">
                    円/分
                  </li>
                  <!-- add DCD-464 20230912 end -->
                  <li>
                    <span class="label">配送費</span>
                    <!-- <input v-if="!isEdit" v-model="planDeliveryCost" type="number" class="bs-input" placeholder="配送費"> -->
                    <input v-if="!isEdit" v-model="planDeliveryCost" type="number" class="bs-input-price" placeholder="配送費">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryCost" type="number" class="bs-input" placeholder="配送費"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planDeliveryCost" type="number" class="bs-input-price" placeholder="配送費">
                    円
                  </li>
                  <li>
                    <span class="label">組立設置費</span>
                    <!-- <input v-if="!isEdit" v-model="planExecutionCost" type="number" class="bs-input" placeholder="組立設置費"> -->
                    <input v-if="!isEdit" v-model="planExecutionCost" type="number" class="bs-input-price" placeholder="組立設置費">
                    <!-- <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planExecutionCost" type="number" class="bs-input" placeholder="組立設置費"> -->
                    <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planExecutionCost" type="number" class="bs-input-price" placeholder="組立設置費">
                    円
                  </li>
                </ul>
              </div>
              <div class="input-area">
                <div class="right">
                  <ul>
                    <li>原価積算
                    </li>
                    <li>
                      <span class="label">営業部門 利益率</span>
                      <input v-if="!isEdit" v-model="planProfitRate1" type="number" class="bs-input" placeholder="営業部門 利益率">
                      <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProfitRate1" type="number" class="bs-input" placeholder="営業部門 利益率">
                      %
                    </li>
                    <li>
                      <span class="label">販社A 利益率</span>
                      <input v-if="!isEdit" v-model="planProfitRate2" type="number" class="bs-input" placeholder="販社A 利益率">
                      <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProfitRate2" type="number" class="bs-input" placeholder="販社A 利益率">
                      %
                    </li>
                    <li>
                      <span class="label">販社B 利益率</span>
                      <input v-if="!isEdit" v-model="planProfitRate3" type="number" class="bs-input" placeholder="販社B 利益率">
                      <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProfitRate3" type="number" class="bs-input" placeholder="販社B 利益率">
                      %
                    </li>
                    <li>
                      <span class="label">販社C 利益率</span>
                      <input v-if="!isEdit" v-model="planProfitRate4" type="number" class="bs-input" placeholder="販社C 利益率">
                      <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planProfitRate4" type="number" class="bs-input" placeholder="販社C 利益率">
                      %
                    </li>
                  </ul>
                </div>
                <div class="right">
                  <ul>
                    <li>設定上代
                    </li>
                    <li>
                      <span class="label">定価</span>
                      <input v-if="!isEdit" v-model="planRegretRate4" type="number" class="bs-input" placeholder="定価">
                      <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planRegretRate4" type="number" class="bs-input" placeholder="定価">
                      %
                    </li>
                    <li>
                      <span class="label">掛率A</span>
                      <input v-if="!isEdit" v-model="planRegretRate3" type="number" class="bs-input" placeholder="掛率A">
                      <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planRegretRate3" type="number" class="bs-input" placeholder="掛率A">
                      %
                    </li>
                    <li>
                      <span class="label">掛率B</span>
                      <input v-if="!isEdit" v-model="planRegretRate2" type="number" class="bs-input" placeholder="掛率B">
                      <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planRegretRate2" type="number" class="bs-input" placeholder="掛率B">
                      %
                    </li>
                    <li>
                      <span class="label">掛率C</span>
                      <input v-if="!isEdit" v-model="planRegretRate1" type="number" class="bs-input" placeholder="掛率C">
                      <input v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planRegretRate1" type="number" class="bs-input" placeholder="掛率C">
                      %
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <!-- カスタム項目 -->
          <section v-if="isActive === 4" class="tab-detail">
            <div class="message_area">
              <span class="custom_message">
              本契約後に使用できます『保存プランリスト』の表示設定に使用します。
              <br>
              保存したプランの案件名や備考項目などを自由に設定できます。
              </span>
            </div>
            <ul>
              <li v-for="(num, index) in 10" :key="index">
                <span class="label">{{ customNameList[num-1] }}</span>
                <input type="text" class="bs-input" v-if="!isEdit" v-model="businessCustom[num]" :placeholder="customNameList[num-1]">
                <input type="text" class="bs-input" v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="uBusinessCustom[num]" :placeholder="'カスタム設定名' + num ">
              </li>
             </ul>
          </section>
          <!-- セットプランルール設定 -->
          <section v-if="isActive === 5" class="tab-detail">
            <div class="sub-title">
              <h3>セットプランルール設定</h3>
            </div>
            <ul>
              <li class="size-input">
                <div><span>最小値</span></div><div class="max-value"><span>最大値</span></div>
              </li>
              <li class="size-input">
                <div class="size-text"><span>W</span></div>
                <input type="number" v-model="ruledSetMinW">
                <input type="number" v-model="ruledSetMaxW">
              </li>
              <li class="size-input">
                <div class="size-text"><span>H</span></div>
                <input type="number" v-model="ruledSetMinH">
                <input type="number" v-model="ruledSetMaxH">
              </li>
              <li class="size-input">
                <div class="size-text"><span>D</span></div>
                <input type="number" v-model="ruledSetMinD">
                <input type="number" v-model="ruledSetMaxD">
              </li>
            </ul>
            <div v-if="ruledAxisType==='Y'" class="ratio-area">
              <div class="top-text">{{ ruledSetData.firstText }}</div>
              <div class="arrow-vertical"></div>
              <div class="bottom-text">{{ ruledSetData.secondText }}</div>
              <div class="vertical-text">{{ ruledSetData.sizeText }}</div>
              <div class="ratio-input-area">
                <ul>
                  <li><span>固定</span></li>
                  <li v-for="(id, index) in srcSpaceIds" :key="index">
                    <input type="checkbox" v-model="ruledSetPlanFix[index]" :disabled="checkFixSpace(id)">
                  </li>
                </ul>
                <ul>
                  <li><span>比率</span></li>
                  <li v-for="(id, index) in srcSpaceIds" :key="index">
                    <input type="number" v-model.number="ruledSetPlanRatio[index]" disabled>
                  </li>
                </ul>
              </div>
            </div>
            <div v-else class="ratio-area horizontal">
              <div class="ratio-input-area">
                <ul>
                  <li><div><span>固定</span></div></li>
                  <li v-for="(id, index) in srcSpaceIds" :key="index">
                    <input type="checkbox" v-model="ruledSetPlanFix[index]" :disabled="checkFixSpace(id)">
                  </li>
                </ul>
                <ul>
                  <li><div><span>比率</span></div></li>
                  <li v-for="(id, index) in srcSpaceIds" :key="index">
                    <input type="number" v-model.number="ruledSetPlanRatio[index]" disabled>
                  </li>
                </ul>
              </div>
              <div class="left-text">{{ ruledSetData.firstText }}</div>
              <div class="arrow-horizontal"></div>
              <div class="right-text">{{ ruledSetData.secondText }}</div>
              <div class="horizontal-text">{{ ruledSetData.sizeText }}</div>
            </div>
          </section>
          <!-- コンテンツデータ設定 -->
          <section v-if="isActive === 6" class="tab-detail">
           <ul>
              <li v-if="isOnlyRegisterContentsData">
                <span class="label">ファイル名</span>
                <div>{{ fileData.fileName }}</div>
              </li>
              <li v-if="isOnlyRegisterContentsData">
                <span class="label">製品品番</span>
                <div>{{ fileData.fileCode }}</div>
              </li>
              <li>
                <span class="label">説明文(短)</span>
                <input type="text" class="bs-input" v-if="!isEdit" v-model="contentsData.contentsTextShort" placeholder="説明文(短)" :disabled="isAddSetOrComb">
                <input type="text" class="bs-input" v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.contentsDataModel.contentsTextShort" placeholder="説明文(短)">
              </li>
              <li>
                <span class="label desp">説明文(長)</span>
                <textarea type="text" class="bs-input" v-if="!isEdit" v-model="contentsData.contentsTextLong" rows="10" placeholder="説明文(長)" :disabled="isAddSetOrComb"></textarea>
                <textarea type="text" class="bs-input" v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.contentsDataModel.contentsTextLong" rows="10" placeholder="説明文(長)"></textarea>
              </li>
              <li>
                <span class="label">画像ファイル(大)</span>
                <div>
                  <label class="file_upload main_btn" :class="{img_disable: !isEdit && isAddSetOrComb}" for="file_upload_big">
                    変更
                    <input type="file" id="file_upload_big" @change="fileChangeImgBig"/>
                  </label>
                  <img :src="getContentsImg('big', 'contentsImgBig')" @error="noImage" class="contents_data_img" width="100px" height="100px"/>
                </div>
              </li>
              <li>
                <span class="label">画像ファイル(中)</span>
                <div>
                  <label class="file_upload main_btn" :class="{img_disable: !isEdit && isAddSetOrComb}" for="file_upload_mid">
                    変更
                    <input type="file" id="file_upload_mid" @change="fileChangeImgMid"/>
                  </label>
                  <img :src="getContentsImg('mid', 'contentsImgMid')" @error="noImage" class="contents_data_img" width="100px" height="100px"/>
                </div>
              </li>
              <li>
                <span class="label">画像ファイル(小)</span>
                <div>
                  <label class="file_upload main_btn" :class="{img_disable: !isEdit && isAddSetOrComb}" for="file_upload_small">
                    変更
                    <input type="file" id="file_upload_small" @change="fileChangeImgSmall"/>
                  </label>
                  <img :src="getContentsImg('small', 'contentsImgSmall')" @error="noImage" class="contents_data_img" width="100px" height="100px"/>
                </div>
              </li>
              <li>
                <span class="label">施工写真ファイル名１</span>
                <div>
                  <label class="file_upload main_btn" :class="{img_disable: !isEdit && isAddSetOrComb}" for="file_upload_const1">
                    変更
                    <input type="file" id="file_upload_const1" @change="fileChangeImgConst1"/>
                  </label>
                  <img :src="getContentsImg('const1', 'contentsImgConst1')" @error="noImage" class="contents_data_img" width="100px" height="100px"/>
                </div>
              </li>
              <li>
                <span class="label">施工写真ファイル名２</span>
                <div>
                  <label class="file_upload main_btn" :class="{img_disable: !isEdit && isAddSetOrComb}" for="file_upload_const2">
                    変更
                    <input type="file" id="file_upload_const2" @change="fileChangeImgConst2"/>
                  </label>
                  <img :src="getContentsImg('const2', 'contentsImgConst2')" @error="noImage" class="contents_data_img" width="100px" height="100px"/>
                </div>
              </li>
              <li>
                <span class="label">施工写真ファイル名３</span>
                <div>
                  <label class="file_upload main_btn" :class="{img_disable: !isEdit && isAddSetOrComb}" for="file_upload_const3">
                    変更
                    <input type="file" id="file_upload_const3" @change="fileChangeImgConst3"/>
                  </label>
                  <img :src="getContentsImg('const3', 'contentsImgConst3')" @error="noImage" class="contents_data_img" width="100px" height="100px"/>
                </div>
              </li>
           </ul>
          </section>
          <!-- スケッチオーダー情報 -->
          <!-- <section v-if="isActive === 7" class="tab-detail">
           <ul>
              <li>
                <span class="label">スケッチID</span>
                <div>{{ fileData.sketchModel.sketchId }}</div>
              </li>
              <li>
                <span class="label">お客様名</span>
                <div>{{ convertSketchName(fileData.sketchModel.userLastName, fileData.sketchModel.userFirstName) + ' 様' }}</div>
              </li>
              <li>
                <span class="label desp">アップロード時コメント</span>
                <textarea readonly v-model="fileData.sketchModel.sketchComment" rows="10" class="bs-input"></textarea>
              </li>
              <li>
                <span class="label">設置場所 種別</span>
                <div>{{ convertInstLocation(fileData.sketchModel.sketchManagerInstLocation) }}</div>
              </li>
              <li>
                <span class="label">エレベータの有無</span>
                <div>{{ convertElevatorFlg(fileData.sketchModel.sketchManagerElevatorFlg) }}</div>
              </li>
           </ul>
          </section> -->
          <!-- 納品情報 -->
          <!-- <section v-if="isActive === 8" class="tab-detail">
           <ul>
              <li>
                <span class="label desp">備考</span>
                <textarea v-if="!isEdit" v-model="planSalesComment" rows="10" class="bs-input" placeholder="備考" :disabled="isAddSetOrComb"></textarea>
                <textarea v-if="isEdit && fileData && Object.keys(fileData).length > 0" v-model="fileData.planDataModel.planSalesComment" rows="10" class="bs-input" placeholder="備考"></textarea>
              </li>
           </ul>
          </section> -->
        </div>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" v-if="!isEdit" @click="createFile(objType, false)" :disabled="canCreatePlan">作成</button>
        <button type="button" class="main_btn" v-if="isEdit && fileData && Object.keys(fileData).length > 0 && !isSaveAs && !isOnlyRegisterContentsData" @click="updateFile" :disabled="canCreatePlan">更新</button>
        <button type="button" class="main_btn" v-if="isEdit && fileData && Object.keys(fileData).length > 0 && isSaveAs" @click="saveAsFileData" :disabled="canCreatePlan">保存</button>
        <button type="button" class="main_btn" v-if="isEdit && fileData && Object.keys(fileData).length > 0 && isOnlyRegisterContentsData" @click="registerContentsData" :disabled="canCreatePlan">保存</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import { mapState } from 'vuex'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import * as SpaceUtil from '../../../utils/Space'
import * as FaceUtil from '../../../utils/Face'
import * as CalcUtil from '../../../utils/Calc'
import {API_URL} from '../../../constants/App'
import {LICENSE_TYPE, OBJECT_TYPE, AXIS_TYPE, OBJECT_DTL_TYPE, FACE_TYPE} from '../../../constants/Type'
import LoadingModal from '../../common/LoadingModal'
import ColorMaterialListModal from '../../planning/modal/ColorMaterialListModal'
import CustomColorListModal from '../../planning/modal/CustomColorListModal'

export default {
  name: 'FileModal',
  components: {
    'dd-loading-modal': LoadingModal,
    'dd-color-material-list-modal': ColorMaterialListModal,
    'dd-custom-color-list-modal': CustomColorListModal
  },
  computed: {
    /** 得意先一覧 */
    ...mapState(['businessList']),
    isPlan: function () {
      return this.objType === OBJECT_TYPE.PLAN.code
    },
    isCombine: function () {
      return this.objType === OBJECT_TYPE.COMBINE.code
    },
    isSetPlan: function () {
      return this.objType === OBJECT_TYPE.SETPLAN.code
    },
    isSetFix: function () {
      return this.objType === OBJECT_TYPE.SETPLAN_FIX.code
    },
    isAddSetOrComb: function () {
      return (this.isCombine || this.isSetPlan || this.isSetFix) && !this.saveCheckFlg
    },
    getSaveName: function () {
      return this.getTypeName ? this.getTypeName + '名' : ''
    },
    isSrvContentsData: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.contentsData
    },
    isOrder: function () {
      let user = App.getUserInfo()
      return user.corpId === 170
    },
    getTypeName: function () {
      let type = Object.values(OBJECT_TYPE)
        .find(e => e.code === this.objType)
      return type ? type.label : ''
    },
    getTitle: function () {
      let title = this.getTypeName
      title += this.isSaveAs ? '保存' : '設定'
      return title
    },
    /** お試しユーザー用ツール表示 */
    dispTrialUserTools: function () {
      let user = App.getUserInfo()
      return user && LICENSE_TYPE.TRIAL === user.licenseType
    },
    setCategoryList: function () {
      let dispCatecoryList = {}
      if (this.isCombine) {
        dispCatecoryList = this.categoryList.filter(category => category.topObjTypeName === OBJECT_TYPE.COMBINE.code || category.categoryNo === this.commonNo)
      } else if (this.isSetPlan || this.isSetFix) {
        dispCatecoryList = this.categoryList.filter(category => category.topObjTypeName === OBJECT_TYPE.SETPLAN.code || category.categoryNo === this.commonNo)
      } else if (this.isPlan) {
        dispCatecoryList = this.categoryList.filter(category => category.topObjTypeName === OBJECT_TYPE.PLAN.code || category.categoryNo === this.commonNo)
      }
      return dispCatecoryList
    },
    /** オーダー家具権限1か91以外ならば、プラン作成・プラン保存ができない */
    canCreatePlan: function () {
      let user = App.getUserInfo()
      let codes = ['1', '91']
      if (this.isActive === 0 && typeof user.userOrderType === 'string') {
        let userOrderType = user.userOrderType.split('|')
        return !codes.some((code) => userOrderType.includes(code))
      }
    },
    layerList: function () {
      const seenLayerIds = new Set()
      let retList = this.profitList.reduce((acc, item) => {
        if (!seenLayerIds.has(item.factorySalesLayerId)) {
          seenLayerIds.add(item.factorySalesLayerId)
          acc.push({ planLayerId: item.factorySalesLayerId, planLayerName: item.factorySalesLayerName })
        }
        return acc
      }, [])
      return retList
    },
    filteredProfitList: function () {
      if (this.planLayer.planLayerId === null) {
        return this.profitList
      }
      return this.profitList.filter(profit => profit.factorySalesLayerId === this.planLayer.planLayerId)
    },
    /** プラン情報 */
    planProfitFormList: function () {
      if (!this.filteredProfitList || !this.filteredProfitList.length) {
        return []
      }
      const layerId = this.planLayer && this.planLayer.planLayerId ? this.planLayer.planLayerId : 1
      return this.filteredProfitList
        .filter(profit => profit.layerId === layerId)
        .map(profit => ({
          planProfitId: profit.factoryProfitId,
          corpId: profit.corpId,
          factoryId: profit.factorySalesLayerId,
          umPlanid: this.fileData.planDataModel.umPlanid,
          planProfitCategory: profit.profitCategoryId,
          planProfitCategoryName: profit.factorySalesLayerName,
          planProfitRate: profit.factoryProfitRate,
          delFlg: profit.delFlg
        }))
    }
  },
  props: {
    /** 選択されたシリーズ情報 */
    series: Object,
    /**
     * 編集時、DBを直接更新するか否か
     * falseならredisキャッシュを更新する
     */
    forceUpdate: Boolean,
    globalSpaceMap: Map
  },
  data () {
    return {
      /** タブリスト */
      tabList: [
        {code: 0, label: '基本情報'},
        {code: 1, label: 'カラー設定'},
        {code: 2, label: '得意先・納品登録'},
        {code: 3, label: '価格計算設定'},
        {code: 4, label: 'カスタム項目'},
        {code: 5, label: 'ルール設定'},
        {code: 6, label: 'コンテンツ'},
        {code: 7, label: '販売利益率設定'}
        // {code: 7, label: 'スケッチオーダー'},
        // {code: 8, label: '納本情報'}
      ],
      /** モーダル判定 */
      modalDispIf: false,
      /** モーダル判定 */
      modalDispShow: true,
      /** タブコンテンツ判定 */
      isActive: 0,
      /** 編集中のファイルの操作であるかの判定値 */
      isEdit: false,
      /** 名前を付けて保存の操作であるかの判定値 */
      isSaveAs: false,
      /** コンテンツデータの登録の操作であるかの判定値 */
      isOnlyRegisterContentsData: false,
      /** ルール付きセットプラン保存であるかの判定値 */
      ruledAxisType: AXIS_TYPE.UNDEFINED,
      /** ルール付きセットプラン用表示データ */
      ruledSetData: {
        firstText: '',
        secondText: '',
        sizeText: ''
      },
      ruledSpaceList: [],
      /** カテゴリー一覧 */
      categoryList: [],
      /** カラースタイル設定 */
      colorStyleConf: {},
      /** カラースタイル名を管理する配列 */
      colorStyleNameList: {},
      /** カラーリストタイプを管理する配列 */
      colorStyleTypeList: {},
      /** カラー素材一覧 */
      colorMaterialList: [],
      /** 選択中の得意先 */
      selectedBusiness: {},
      /** 構成明細カスタム名一覧 */
      customNameList: [],
      /** 掛け率一覧 */
      profitList: [],
      message: '',
      errorMessage: { text: '' },
      objType: '',
      fileData: {},
      uRoomSize: {},
      uColorStyleGrp: {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      uColorStyleGrpStr: {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      uColorStyleGrpColor: {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      uBusinessCustom: {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      // *****************************************************************
      // 新規ファイル入力項目
      // *****************************************************************
      planPropertyName: '',
      name: '',
      roomSize: {w: 2500, h: 2400, d: 2500},
      // maxRoomSize: {w: '', h: '', d: ''},
      // minRoomSize: {w: '', h: '', d: ''},
      // del 戻す 20230726 start
      // planRoomW: 2500,
      // planRoomH: 2400,
      // // planRoomD: 2500,
      // plamWallL: 0,
      // planWallR: 0,
      // del 戻す 20230726 end
      categoryNo: '',
      fileCode: '',
      planCount: '',
      planSalesComment: '',
      fileCaption: '',
      saveCheckFlg: false,
      colorStyleDefault: '',
      colorStyleDefaultStr: '',
      colorStyleDefaultColor: '',
      colorStyleGrp: {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      colorStyleGrpStr: {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      colorStyleGrpColor: {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      planDeliveryName: '',
      planDeliveryCountry: '',
      planDeliveryPostcd: '',
      planDeliveryState: '',
      planDeliveryCity: '',
      planDeliveryStreet: '',
      planDeliveryBuilding: '',
      planDeliveryFloor: '',
      planDeliveryTel: '',
      planDeliveryFax: '',
      planDeliveryLastName: '',
      planDeliveryFirstName: '',
      planDeliveryLastNameKana: '',
      planDeliveryFirstNameKana: '',
      planDeliveryNotice: '',
      planEcInfoDeliPref1: '',
      planEcHealthCare: 0,
      planLayer: {},
      selectTime: '',
      textDateTime: '',
      planEcInfoBtPref1: '',
      planEcInfoBtPref2: '',
      planEcInfoBtPref3: '',
      planEstProbDisableFlg: false,
      planMaterialMagProb: '',
      planProcessCostMin: '',
      planProcessMagProb: '',
      planProcessProfitProb: '',
      planFacttransCost: '',
      // add DCD-464 20230912 start
      planExecutionCostPerson: '',
      planExecutionCostCar: '',
      planExecutionCostMin: '',
      planMobilizationCostPerson: '',
      // add DCD-464 20230912 end
      planDeliveryCost: '',
      planExecutionCost: '',
      planProfitRate1: '',
      planProfitRate2: '',
      planProfitRate3: '',
      planProfitRate4: '',
      planRegretRate1: '',
      planRegretRate2: '',
      planRegretRate3: '',
      planRegretRate4: '',
      businessId: '',
      businessCustom: {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      srcSpaceJoincd: '',
      srcSpaceIds: [],
      ruledSetPlanRatio: [],
      ruledSetPlanFix: [],
      ruledSetMinW: '',
      ruledSetMinH: '',
      ruledSetMinD: '',
      ruledSetMaxW: '',
      ruledSetMaxH: '',
      ruledSetMaxD: '',
      axisType: 0,
      /** コンテンツデータ */
      maxFileSize: 0,
      contentsData: {
        corpId: '',
        contentsType: '',
        umCode: '',
        code: '',
        contentsPriority: '',
        contentsTextShort: '',
        contentsTextLong: '',
        contentsImgBig: '',
        contentsImgMid: '',
        contentsImgSmall: '',
        contentsRemark: '',
        delFlg: false
      },
      contentsDataUploadFile: {
        big: null,
        mid: null,
        small: null,
        const1: null,
        const2: null,
        const3: null
      },
      validateErrorMessages: {},
      validateCustomErrorMessages: {},
      imgQMark: this.getImage('pages/planning/qmark_gray.svg'),
      commonNo: 1,
      healthCareList: [
        {code: '0', label: ''},
        {code: '1', label: '完全養生'},
        {code: '2', label: '簡易養生'}
      ]
    }
  },
  watch: {
    series: function () {
      this.getColorStyleConf(this.series.seriesColorStyleConfigId)
    },
    modalDispShow: function () {
      this.operateEventListener()
    },
    modalDispIf: function () {
      this.operateEventListener()
    },
    fileData: function () {
      if (this.fileData.colorStyleDataModelList && this.fileData.colorStyleDataModelList.length > 0) {
        this.uColorStyleGrp[1] = this.fileData.colorStyleDataModelList[0].colorStyleGroup1
        this.uColorStyleGrp[2] = this.fileData.colorStyleDataModelList[0].colorStyleGroup2
        this.uColorStyleGrp[3] = this.fileData.colorStyleDataModelList[0].colorStyleGroup3
        this.uColorStyleGrp[4] = this.fileData.colorStyleDataModelList[0].colorStyleGroup4
        this.uColorStyleGrp[5] = this.fileData.colorStyleDataModelList[0].colorStyleGroup5
        this.uColorStyleGrp[6] = this.fileData.colorStyleDataModelList[0].colorStyleGroup6
        this.uColorStyleGrp[7] = this.fileData.colorStyleDataModelList[0].colorStyleGroup7
        this.uColorStyleGrp[8] = this.fileData.colorStyleDataModelList[0].colorStyleGroup8
        this.uColorStyleGrp[9] = this.fileData.colorStyleDataModelList[0].colorStyleGroup9
        this.uColorStyleGrp[10] = this.fileData.colorStyleDataModelList[0].colorStyleGroup10
        this.uColorStyleGrpStr[1] = this.fileData.colorStyleDataModelList[0].colorStyleGroup1Str
        this.uColorStyleGrpStr[2] = this.fileData.colorStyleDataModelList[0].colorStyleGroup2Str
        this.uColorStyleGrpStr[3] = this.fileData.colorStyleDataModelList[0].colorStyleGroup3Str
        this.uColorStyleGrpStr[4] = this.fileData.colorStyleDataModelList[0].colorStyleGroup4Str
        this.uColorStyleGrpStr[5] = this.fileData.colorStyleDataModelList[0].colorStyleGroup5Str
        this.uColorStyleGrpStr[6] = this.fileData.colorStyleDataModelList[0].colorStyleGroup6Str
        this.uColorStyleGrpStr[7] = this.fileData.colorStyleDataModelList[0].colorStyleGroup7Str
        this.uColorStyleGrpStr[8] = this.fileData.colorStyleDataModelList[0].colorStyleGroup8Str
        this.uColorStyleGrpStr[9] = this.fileData.colorStyleDataModelList[0].colorStyleGroup9Str
        this.uColorStyleGrpStr[10] = this.fileData.colorStyleDataModelList[0].colorStyleGroup10Str
        this.uColorStyleGrpColor[1] = this.fileData.colorStyleDataModelList[0].colorStyleGroup1Color
        this.uColorStyleGrpColor[2] = this.fileData.colorStyleDataModelList[0].colorStyleGroup2Color
        this.uColorStyleGrpColor[3] = this.fileData.colorStyleDataModelList[0].colorStyleGroup3Color
        this.uColorStyleGrpColor[4] = this.fileData.colorStyleDataModelList[0].colorStyleGroup4Color
        this.uColorStyleGrpColor[5] = this.fileData.colorStyleDataModelList[0].colorStyleGroup5Color
        this.uColorStyleGrpColor[6] = this.fileData.colorStyleDataModelList[0].colorStyleGroup6Color
        this.uColorStyleGrpColor[7] = this.fileData.colorStyleDataModelList[0].colorStyleGroup7Color
        this.uColorStyleGrpColor[8] = this.fileData.colorStyleDataModelList[0].colorStyleGroup8Color
        this.uColorStyleGrpColor[9] = this.fileData.colorStyleDataModelList[0].colorStyleGroup9Color
        this.uColorStyleGrpColor[10] = this.fileData.colorStyleDataModelList[0].colorStyleGroup10Color
      }
      if (this.fileData.planDataModel) {
        this.uBusinessCustom[1] = this.fileData.planDataModel.planCustom1
        this.uBusinessCustom[2] = this.fileData.planDataModel.planCustom2
        this.uBusinessCustom[3] = this.fileData.planDataModel.planCustom3
        this.uBusinessCustom[4] = this.fileData.planDataModel.planCustom4
        this.uBusinessCustom[5] = this.fileData.planDataModel.planCustom5
        this.uBusinessCustom[6] = this.fileData.planDataModel.planCustom6
        this.uBusinessCustom[7] = this.fileData.planDataModel.planCustom7
        this.uBusinessCustom[8] = this.fileData.planDataModel.planCustom8
        this.uBusinessCustom[9] = this.fileData.planDataModel.planCustom9
        this.uBusinessCustom[10] = this.fileData.planDataModel.planCustom10
      }
    },
    ruledSetPlanFix: function () {
      this.calcSpaceRatio(this.ruledSpaceList) // move to:bugfix:DCD-459 20230628
      this.setRuledMaxMin(this.ruledSpaceList)
      // this.calcSpaceRatio(this.ruledSpaceList) // move from:bugfix:DCD-459 20230628
    }
  },
  methods: {
    // *****************************************************************
    // 親コンポーネントから呼ばれる関数
    // *****************************************************************
    /**
     * 要素の削除
     */
    clearElement: function () {
      this.modalDispShow = false
      this.modalDispIf = false
    },
    /**
     * 新規作成モーダル表示
     * コンバインで保存、セットプランで保存から呼ばれる
     */
    showCreateModal: function (fileData, objType, srcSpaceJoincd = '', srcSpaceIds = [], axisType) {
      this.fileData = fileData
      this.modalDispIf = true
      this.modalDispShow = false
      this.clearCache()
      this.objType = objType
      this.isEdit = false
      this.isSaveAs = false
      this.isOnlyRegisterContentsData = false
      this.setRuledData(srcSpaceIds, axisType)
      this.srcSpaceJoincd = srcSpaceJoincd
      this.srcSpaceIds = srcSpaceIds
      Object.keys(this.contentsDataUploadFile).forEach(k => {
        this.contentsDataUploadFile[k] = null
      })
      this.modalDispShow = true
    },

    /**
     * ファイル編集モーダル表示
     * 設定から呼ばれる
     */
    showEditModal: function (objType, spaceJoincd) {
      console.log('call showEditModal')
      this.modalDispIf = true
      this.modalDispShow = false
      this.getCustomName()
      let fileData = {}
      Object.keys(this.contentsDataUploadFile).forEach(k => {
        this.contentsDataUploadFile[k] = null
      })
      this.$refs.loadingModalRef.showModal(true)
      axios.get(API_URL.PLANNING + '/edit-config/' + spaceJoincd, {
        params: {
          force: this.forceUpdate
        }
      }).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        fileData = response.data.data
        this.clearCache()
        this.objType = objType
        this.isEdit = true
        this.isSaveAs = false
        this.isOnlyRegisterContentsData = false
        this.fileData = fileData
        this.modalDispShow = true
        this.setSelectedBusiness()
        // 掛け率の表示を％にする
        this.fileData.planDataModel.planMaterialMagProb = this.innerHangingToPercent(this.fileData.planDataModel.planMaterialMagProb)
        this.fileData.planDataModel.planProcessMagProb = this.innerHangingToPercent(this.fileData.planDataModel.planProcessMagProb)
        this.fileData.planDataModel.planProcessProfitProb = this.innerHangingToPercent(this.fileData.planDataModel.planProcessProfitProb)
        this.fileData.planDataModel.planProfitRate1 = this.hangingToPercent(this.fileData.planDataModel.planProfitRate1)
        this.fileData.planDataModel.planProfitRate2 = this.hangingToPercent(this.fileData.planDataModel.planProfitRate2)
        this.fileData.planDataModel.planProfitRate3 = this.hangingToPercent(this.fileData.planDataModel.planProfitRate3)
        this.fileData.planDataModel.planProfitRate4 = this.hangingToPercent(this.fileData.planDataModel.planProfitRate4)
        // mdf DCD-463 20230829 start
        // this.fileData.planDataModel.planRegretRate1 = this.fileData.planDataModel.planRegretRate1 * 100
        // this.fileData.planDataModel.planRegretRate2 = this.fileData.planDataModel.planRegretRate2 * 100
        // this.fileData.planDataModel.planRegretRate3 = this.fileData.planDataModel.planRegretRate3 * 100
        // this.fileData.planDataModel.planRegretRate4 = this.fileData.planDataModel.planRegretRate4 * 100
        this.fileData.planDataModel.planRegretRate1 = Math.round(this.fileData.planDataModel.planRegretRate1 * 100)
        this.fileData.planDataModel.planRegretRate2 = Math.round(this.fileData.planDataModel.planRegretRate2 * 100)
        this.fileData.planDataModel.planRegretRate3 = Math.round(this.fileData.planDataModel.planRegretRate3 * 100)
        this.fileData.planDataModel.planRegretRate4 = Math.round(this.fileData.planDataModel.planRegretRate4 * 100)
        // mdf DCD-463 20230829 end
        if (this.fileData.planEcModel.ecHealthCare !== null) {
          this.planEcHealthCare = this.fileData.planEcModel.ecHealthCare
        }
        if (this.fileData.planDataModel.planLayerId) {
          this.planLayer = {planLayerId: this.fileData.planDataModel.planLayerId, planLayerName: this.fileData.planDataModel.planLayerName}
        }
        console.log('layer Id:')
        console.log(this.fileData.planDataModel.planLayerId)
        console.log(this.planLayer)
        // 日付をフォーマット
        this.fileData.planEcModel.ecInfoDeliPref1 = this.getFormatDate(this.fileData.planEcModel.ecInfoDeliPref1)
        this.fileData.planEcModel.ecInfoBtPref1 = this.getFormatDate(this.fileData.planEcModel.ecInfoBtPref1)
        this.fileData.planEcModel.ecInfoBtPref2 = this.getFormatDate(this.fileData.planEcModel.ecInfoBtPref2)
        this.fileData.planEcModel.ecInfoBtPref3 = this.getFormatDate(this.fileData.planEcModel.ecInfoBtPref3)
        // 納品時間の選択
        if (this.fileData.planEcModel.ecInfoDeliPref1StTime === 8 && this.fileData.planEcModel.ecInfoDeliPref1EndTime === 12) {
          this.selectTime = 1
        } else if (this.fileData.planEcModel.ecInfoDeliPref1StTime === 12 && this.fileData.planEcModel.ecInfoDeliPref1EndTime === 15) {
          this.selectTime = 2
        } else {
          this.selectTime = 0
        }
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error)
      })
    },
    /**
     * 名前を付けて保存モーダル表示
     * 新規作成中のファイルを保存、名前をつけて保存から呼ばれる
     */
    showSaveAsModal: function (objType, spaceJoincd) {
      this.modalDispIf = true
      this.modalDispShow = false
      this.getCustomName()
      let fileData = {}
      Object.keys(this.contentsDataUploadFile).forEach(k => {
        this.contentsDataUploadFile[k] = null
      })
      this.$refs.loadingModalRef.showModal(true)
      axios.get(API_URL.PLANNING + '/edit-config/' + spaceJoincd, {
        params: {
          force: this.forceUpdate
        }
      }).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        fileData = response.data.data
        this.clearCache()
        this.objType = objType
        this.isEdit = true
        this.isSaveAs = true
        this.isOnlyRegisterContentsData = false
        this.fileData = fileData
        this.modalDispShow = true
        this.setSelectedBusiness()
        if (this.isPlan && !this.fileData.fileCode) {
          this.fileData.fileCode = this.fileData.planDataModel.umPlanid
        }
        // 掛け率の表示を％にする
        this.fileData.planDataModel.planMaterialMagProb = this.innerHangingToPercent(this.fileData.planDataModel.planMaterialMagProb)
        this.fileData.planDataModel.planProcessMagProb = this.innerHangingToPercent(this.fileData.planDataModel.planProcessMagProb)
        this.fileData.planDataModel.planProcessProfitProb = this.innerHangingToPercent(this.fileData.planDataModel.planProcessProfitProb)
        this.fileData.planDataModel.planProfitRate1 = this.hangingToPercent(this.fileData.planDataModel.planProfitRate1)
        this.fileData.planDataModel.planProfitRate2 = this.hangingToPercent(this.fileData.planDataModel.planProfitRate2)
        this.fileData.planDataModel.planProfitRate3 = this.hangingToPercent(this.fileData.planDataModel.planProfitRate3)
        this.fileData.planDataModel.planProfitRate4 = this.hangingToPercent(this.fileData.planDataModel.planProfitRate4)
        // mdf DCD-463 20230829 start
        // this.fileData.planDataModel.planRegretRate1 = this.fileData.planDataModel.planRegretRate1 * 100
        // this.fileData.planDataModel.planRegretRate2 = this.fileData.planDataModel.planRegretRate2 * 100
        // this.fileData.planDataModel.planRegretRate3 = this.fileData.planDataModel.planRegretRate3 * 100
        // this.fileData.planDataModel.planRegretRate4 = this.fileData.planDataModel.planRegretRate4 * 100
        this.fileData.planDataModel.planRegretRate1 = Math.round(this.fileData.planDataModel.planRegretRate1 * 100)
        this.fileData.planDataModel.planRegretRate2 = Math.round(this.fileData.planDataModel.planRegretRate2 * 100)
        this.fileData.planDataModel.planRegretRate3 = Math.round(this.fileData.planDataModel.planRegretRate3 * 100)
        this.fileData.planDataModel.planRegretRate4 = Math.round(this.fileData.planDataModel.planRegretRate4 * 100)
        // mdf DCD-463 20230829 end
        // 日付をフォーマット
        this.fileData.planEcModel.ecInfoDeliPref1 = this.getFormatDate(this.fileData.planEcModel.ecInfoDeliPref1)
        this.fileData.planEcModel.ecInfoBtPref1 = this.getFormatDate(this.fileData.planEcModel.ecInfoBtPref1)
        this.fileData.planEcModel.ecInfoBtPref2 = this.getFormatDate(this.fileData.planEcModel.ecInfoBtPref2)
        this.fileData.planEcModel.ecInfoBtPref3 = this.getFormatDate(this.fileData.planEcModel.ecInfoBtPref3)
        // 納品時間の選択
        if (this.fileData.planEcModel.ecInfoDeliPref1StTime === 8 && this.fileData.planEcModel.ecInfoDeliPref1EndTime === 12) {
          this.selectTime = 1
        } else if (this.fileData.planEcModel.ecInfoDeliPref1StTime === 12 && this.fileData.planEcModel.ecInfoDeliPref1EndTime === 15) {
          this.selectTime = 2
        } else {
          this.selectTime = 0
        }
        // プラン/セットプラン名
        // 上書き保存は当処理の対象外
        // プランの新規保存 --> サーバで亀井ロジックにより設定したプラン名（fileName)があれば初期値として利用する。亀井ロジック対象外であれば未設定。
        // プランの名前を付けて保存 --> 現在のプラン名をそのまま利用（サーバの亀井ロジックでは既存のプラン名を変更しない）
        // セットプランの新規保存 --> ファイル名は空欄にする（サーバで亀井ロジックによって設定された初期値は破棄する）
        // セットプランに対する名前を付けて保存、というケースはない
        if (this.isSetPlan || this.isSetFix) {
          this.fileData.fileName = ''
        }
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error)
      })
    },
    getCustomName: function () {
      axios.get(API_URL.ADMIN + '/get-bom-custom'
      ).then(response => {
        let data = response.data.data
        this.customNameList[0] = data.bomCustomName1 ? data.bomCustomName1 : 'カスタム設定名１'
        this.customNameList[1] = data.bomCustomName2 ? data.bomCustomName2 : 'カスタム設定名２'
        this.customNameList[2] = data.bomCustomName3 ? data.bomCustomName3 : 'カスタム設定名３'
        this.customNameList[3] = data.bomCustomName4 ? data.bomCustomName4 : 'カスタム設定名４'
        this.customNameList[4] = data.bomCustomName5 ? data.bomCustomName5 : 'カスタム設定名５'
        this.customNameList[5] = data.bomCustomName6 ? data.bomCustomName6 : 'カスタム設定名６'
        this.customNameList[6] = data.bomCustomName7 ? data.bomCustomName7 : 'カスタム設定名７'
        this.customNameList[7] = data.bomCustomName8 ? data.bomCustomName8 : 'カスタム設定名８'
        this.customNameList[8] = data.bomCustomName9 ? data.bomCustomName9 : 'カスタム設定名９'
        this.customNameList[9] = data.bomCustomName10 ? data.bomCustomName10 : 'カスタム設定名１０'
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /**
     * コンテンツデータのタブだけを表示
     * コンテンツデータ登録ボタンから呼ばれる
     */
    showContentsDataModal: function (fileData) {
      this.modalDispIf = true
      this.modalDispShow = false
      this.fileData = {}
      this.fileData = fileData
      Object.keys(this.contentsDataUploadFile).forEach(k => {
        this.contentsDataUploadFile[k] = null
      })
      this.clearCache()
      this.objType = fileData.topSpaceModel.spaceObjectType
      this.isOnlyRegisterContentsData = true
      this.isEdit = true
      this.isSaveAs = false
      this.isActive = 7
      this.modalDispShow = true
    },
    // *****************************************************************
    // 新規作成、更新、保存
    // *****************************************************************
    /**
     * ファイルデータの新規作成
     */
    createFile: function (objType, forceClearCache) {
      if (forceClearCache) this.clearCache()
      this.objType = objType

      // ルール付きセットプランの場合は入力チェック
      if (this.ruledAxisType !== AXIS_TYPE.UNDEFINED) {
        let minMaxList = [this.ruledSetMinW, this.ruledSetMaxW, this.ruledSetMinH, this.ruledSetMaxH, this.ruledSetMinD, this.ruledSetMaxD]
        let isVarid = this.validMinMax(minMaxList, 'setPlanCombineForm', '最小値・最大値')
        if (!isVarid) {
          this.showValidationErrorModal()
          return
        }
      }
      /** 基本情報 */
      let basicFileDataForm = {
        fileName: this.name,
        fileObjectType: this.objType,
        roomSize: this.roomSize,
        // maxRoomSize: this.maxRoomSize,
        // minRoomSize: this.minRoomSize,
        seriesNo: this.series.seriesNo,
        categoryNo: this.categoryNo,
        fileCode: this.fileCode,
        fileCaption: this.fileCaption,
        saveCheckFlg: this.saveCheckFlg
      }

      // 先に重複チェック
      if ((this.isSetPlan || this.isSetFix || this.isCombine) && this.saveCheckFlg) {
        this.validateErrorMessages = {}
        axios.post(API_URL.PLANNING + '/check/existing-code', basicFileDataForm
        ).then(response => {
          if (response.data.data.isExisting) {
            if (response.data.data.isSameFileType) {
              App.showModal({
                messages: ['すでに存在する製品品番です。上書きしますか？'],
                modalType: 'confirm',
                textAlign: 'center',
                onOk: () => {
                  this.createNewFile(basicFileDataForm, true)
                }
              })
            } else {
              App.showModal({
                title: 'エラー',
                messages: ['別のファイルタイプで既に使用している製品品番です。'],
                messageType: 'error'
              })
            }
          } else {
            this.createNewFile(basicFileDataForm, false)
          }
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.replaceErrorMessage(error)
          this.showValidationErrorModal()
        })
      } else {
        this.createNewFile(basicFileDataForm, false)
      }
    },
    // ファイルの新規作成処理
    createNewFile: function (basicFileDataForm, updateFlg) {
      // 上書き更新フラグを設定
      basicFileDataForm.updateFlg = updateFlg

      let colorStyleForm = {
        colorStyleDefault: this.colorStyleDefault,
        colorStyleGroup1: this.colorStyleGrp[1],
        colorStyleGroup2: this.colorStyleGrp[2],
        colorStyleGroup3: this.colorStyleGrp[3],
        colorStyleGroup4: this.colorStyleGrp[4],
        colorStyleGroup5: this.colorStyleGrp[5],
        colorStyleGroup6: this.colorStyleGrp[6],
        colorStyleGroup7: this.colorStyleGrp[7],
        colorStyleGroup8: this.colorStyleGrp[8],
        colorStyleGroup9: this.colorStyleGrp[9],
        colorStyleGroup10: this.colorStyleGrp[10],
        colorStyleDefaultStr: this.colorStyleDefaultStr,
        colorStyleGroup1Str: this.colorStyleGrpStr[1],
        colorStyleGroup2Str: this.colorStyleGrpStr[2],
        colorStyleGroup3Str: this.colorStyleGrpStr[3],
        colorStyleGroup4Str: this.colorStyleGrpStr[4],
        colorStyleGroup5Str: this.colorStyleGrpStr[5],
        colorStyleGroup6Str: this.colorStyleGrpStr[6],
        colorStyleGroup7Str: this.colorStyleGrpStr[7],
        colorStyleGroup8Str: this.colorStyleGrpStr[8],
        colorStyleGroup9Str: this.colorStyleGrpStr[9],
        colorStyleGroup10Str: this.colorStyleGrpStr[10],
        colorStyleDefaultColor: this.colorStyleDefaultColor,
        colorStyleGroup1Color: this.colorStyleGrpColor[1],
        colorStyleGroup2Color: this.colorStyleGrpColor[2],
        colorStyleGroup3Color: this.colorStyleGrpColor[3],
        colorStyleGroup4Color: this.colorStyleGrpColor[4],
        colorStyleGroup5Color: this.colorStyleGrpColor[5],
        colorStyleGroup6Color: this.colorStyleGrpColor[6],
        colorStyleGroup7Color: this.colorStyleGrpColor[7],
        colorStyleGroup8Color: this.colorStyleGrpColor[8],
        colorStyleGroup9Color: this.colorStyleGrpColor[9],
        colorStyleGroup10Color: this.colorStyleGrpColor[10]
      }
      let planDataForm = {
        planCount: this.planCount,
        // del 戻す 20230726 start
        // planRoomW: this.isPlan ? this.planRoomW : 0,
        // planRoomH: this.isPlan ? this.planRoomH : 0,
        // // planRoomD: this.isPlan ? this.planRoomD : 0,
        // planWallL: this.isPlan ? this.planWallL : 0,
        // planWallR: this.isPlan ? this.planWallR : 0,
        // del 戻す 20230726 end
        planSalesComment: this.planSalesComment,
        planPropertyName: this.isPlan ? this.planPropertyName : 'dummy',
        planBusinessId: this.businessId,
        planDeliveryName: this.planDeliveryName,
        planDeliveryCountry: this.planDeliveryCountry,
        planDeliveryPostcd: this.planDeliveryPostcd,
        planDeliveryState: this.planDeliveryState,
        planDeliveryCity: this.planDeliveryCity,
        planDeliveryStreet: this.planDeliveryStreet,
        planDeliveryBuilding: this.planDeliveryBuilding,
        planDeliveryFloor: this.planDeliveryFloor,
        planDeliveryTel: this.planDeliveryTel,
        planDeliveryFax: this.planDeliveryFax,
        planDeliverryLastName: this.planDeliveryLastName,
        planDeliverryFirstName: this.planDeliveryFirstName,
        planDeliverryLastNameKana: this.planDeliveryLastNameKana,
        planDeliverryFirstNameKana: this.planDeliveryFirstNameKana,
        planDeliverryNotice: this.planDeliverryNotice,
        planEcInfoDeliPref1: this.planEcInfoDeliPref1,
        planEcHealthCare: this.planEcHealthCare,
        planLayerId: this.planLayer.planLayerId,
        planLayerName: this.planLayer.planLayerName,
        selectTime: this.selectTime,
        planEcInfoBtPref1: this.planEcInfoBtPref1,
        planEcInfoBtPref2: this.planEcInfoBtPref2,
        planEcInfoBtPref3: this.planEcInfoBtPref3,
        planEstProbDisableFlg: this.planEstProbDisableFlg,
        planMaterialMagProb: this.isPlan ? this.planMaterialMagProb : 0.0,
        planProcessCostMin: this.isPlan ? this.planProcessCostMin : 0,
        planProcessMagProb: this.isPlan ? this.planProcessMagProb : 0.0,
        planProcessProfitProb: this.isPlan ? this.planProcessProfitProb : 0.0,
        planFacttransCost: this.isPlan ? this.planFacttransCost : 0,
        // add DCD-464 20230912 start
        planExecutionCostPerson: this.isPlan ? this.planExecutionCostPerson : 0,
        planExecutionCostCar: this.isPlan ? this.planExecutionCostCar : 0,
        planExecutionCostMin: this.isPlan ? this.planExecutionCostMin : 0,
        planMobilizationCostPerson: this.isPlan ? this.planMobilizationCostPerson : 0,
        // add DCD-464 20230912 end
        planProfitRate1: this.isPlan ? this.planProfitRate1 : 1.0,
        planProfitRate2: this.isPlan ? this.planProfitRate2 : 1.0,
        planProfitRate3: this.isPlan ? this.planProfitRate3 : 1.0,
        planProfitRate4: this.isPlan ? this.planProfitRate4 : 1.0,
        planRegretRate1: this.isPlan ? this.planRegretRate1 : 1.0,
        planRegretRate2: this.isPlan ? this.planRegretRate2 : 1.0,
        planRegretRate3: this.isPlan ? this.planRegretRate3 : 1.0,
        planRegretRate4: this.isPlan ? this.planRegretRate4 : 1.0,
        planDeliveryCost: this.isPlan ? this.planDeliveryCost : 0,
        planExecutionCost: this.isPlan ? this.planExecutionCost : 0,
        planCustom1: this.businessCustom[1],
        planCustom2: this.businessCustom[2],
        planCustom3: this.businessCustom[3],
        planCustom4: this.businessCustom[4],
        planCustom5: this.businessCustom[5],
        planCustom6: this.businessCustom[6],
        planCustom7: this.businessCustom[7],
        planCustom8: this.businessCustom[8],
        planCustom9: this.businessCustom[9],
        planCustom10: this.businessCustom[10]
      }
      let setPlanCombineForm = {
        spaceJoincd: this.srcSpaceJoincd,
        spaceIds: this.srcSpaceIds,
        ratioDataList: this.ruledSetPlanRatio,
        minW: this.ruledSetMinW,
        maxW: this.ruledSetMaxW,
        minH: this.ruledSetMinH,
        maxH: this.ruledSetMaxH,
        minD: this.ruledSetMinD,
        maxD: this.ruledSetMaxD,
        axisType: this.axisType
      }
      let contentsDataForm = {}
      if (this.fileData.contentsDataModel != null) {
        contentsDataForm = {
          corpId: this.contentsData.corpId,
          contentsType: this.contentsData.contentsType,
          umCode: this.contentsData.umCode,
          code: this.contentsData.code,
          contentsPriority: this.contentsData.contentsPriority,
          contentsTextShort: this.contentsData.contentsTextShort,
          contentsTextLong: this.contentsData.contentsTextLong,
          contentsImgBig: this.contentsData.contentsImgBig,
          contentsImgMid: this.contentsData.contentsImgMid,
          contentsImgSmall: this.contentsData.contentsImgSmall,
          contentsImgConst1: this.contentsData.contentsImgConst1,
          contentsImgConst2: this.contentsData.contentsImgConst2,
          contentsImgConst3: this.contentsData.contentsImgConst3,
          contentsRemark: this.contentsData.contentsRemark,
          delFlg: this.contentsData.delFlg
        }
      }

      let payload = new FormData()
      if (this.contentsDataUploadFile.big != null) {
        payload.append('contentsImgBig', new Blob([this.contentsDataUploadFile.big],
          {type: this.contentsDataUploadFile.big.type}), this.contentsDataUploadFile.big.name)
      }
      if (this.contentsDataUploadFile.mid != null) {
        payload.append('contentsImgMid', new Blob([this.contentsDataUploadFile.mid],
          {type: this.contentsDataUploadFile.mid.type}), this.contentsDataUploadFile.mid.name)
      }
      if (this.contentsDataUploadFile.small != null) {
        payload.append('contentsImgSmall', new Blob([this.contentsDataUploadFile.small],
          {type: this.contentsDataUploadFile.small.type}), this.contentsDataUploadFile.small.name)
      }
      if (this.contentsDataUploadFile.const1 != null) {
        payload.append('contentsImgConst1', new Blob([this.contentsDataUploadFile.const1],
          {type: this.contentsDataUploadFile.const1.type}), this.contentsDataUploadFile.const1.name)
      }
      if (this.contentsDataUploadFile.const2 != null) {
        payload.append('contentsImgConst2', new Blob([this.contentsDataUploadFile.const2],
          {type: this.contentsDataUploadFile.const2.type}), this.contentsDataUploadFile.const2.name)
      }
      if (this.contentsDataUploadFile.const3 != null) {
        payload.append('contentsImgConst3', new Blob([this.contentsDataUploadFile.const3],
          {type: this.contentsDataUploadFile.const3.type}), this.contentsDataUploadFile.const3.name)
      }
      payload.append('basicFileDataForm', JSON.stringify(basicFileDataForm))
      payload.append('colorStyleForm', JSON.stringify(colorStyleForm))
      payload.append('planDataForm', JSON.stringify(planDataForm))
      payload.append('setPlanCombineForm', JSON.stringify(setPlanCombineForm))
      payload.append('contentsDataForm', JSON.stringify(contentsDataForm))

      axios.post(API_URL.PLANNING + '/new', payload
      ).then(response => {
        if (response.data.errorMessage) {
          if (Object.keys(response.data.validationErrors).length > 0) {
            this.errorMessage.text = response.data.errorMessage
          } else {
            App.showModal({
              title: 'エラー',
              messages: [response.data.errorMessage],
              messageType: 'error'
            })
          }
        } else {
          this.modalDispIf = false
          this.$emit('setResponseData', response)
          this.$emit('setSectionPosition', true)
          this.$emit('clearSpaceTreeFlg')
          this.$emit('closeSelectSpaceModal')
          App.showModal({
            messages: ['作成しました。'],
            onOk: () => {
              if (this.isCombine || this.isSetPlan || this.isSetFix) {
                // セットプランの作成またはコンバインの作成ならばDB登録まで行われているのでファイルデータを再読込
                this.$emit('getAllFileList')
              }
              // if (this.isPlan) { // del 戻す 20230726
              //   // プラン設定画面を開く add DCD-328 20230510
              //   this.showEditModal(OBJECT_TYPE.PLAN.code, response.data.data.spaceJoincd)
              // }
            }
          })
        }
      }).catch(error => {
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        this.replaceErrorMessage(error)
        this.showValidationErrorModal()
      })
    },
    /**
     * ファイルデータの更新
     */
    updateFile: function () {
      // 数値入力のバリデーションチェック
      let validList = []
      if (this.isPlan) {
        validList.push(this.validCount(this.fileData.planDataModel.planCount, 'planDataForm.planCount', '数量'))
        validList.push(this.validRate(this.fileData.planDataModel.planMaterialMagProb, 'planDataForm.planMaterialMagProb', '材料管理費率'))
        validList.push(this.validCost(this.fileData.planDataModel.planProcessCostMin, 'planDataForm.planProcessCostMin', '加工費 分レート'))
        validList.push(this.validRate(this.fileData.planDataModel.planProcessMagProb, 'planDataForm.planProcessMagProb', '生産管理費率'))
        validList.push(this.validRate(this.fileData.planDataModel.planProcessProfitProb, 'planDataForm.planProcessProfitProb', '工場利益率'))
        validList.push(this.validCost(this.fileData.planDataModel.planFacttransCost, 'planDataForm.planFacttransCost', '輸送賃'))
        // add DCD-464 20230912 start
        validList.push(this.validCost(this.fileData.planDataModel.planExecutionCostPerson, 'planDataForm.planExecutionCostPerson', '施工人件費単価'))
        validList.push(this.validCost(this.fileData.planDataModel.planExecutionCostCar, 'planDataForm.planExecutionCostCar', '施工駐車場単価'))
        validList.push(this.validCost(this.fileData.planDataModel.planExecutionCostMin, 'planDataForm.planExecutionCostMin', '施工費最低保証金額'))
        validList.push(this.validCost(this.fileData.planDataModel.planMobilizationCostPerson, 'planDataForm.planMobilizationCostPerson', '搬入人件費単価'))
        // add DCD-464 20230912 end
        validList.push(this.validRate(this.fileData.planDataModel.planProfitRate1, 'planDataForm.planProfitRate1', '営業部門 利益率'))
        validList.push(this.validRate(this.fileData.planDataModel.planProfitRate2, 'planDataForm.planProfitRate2', '販社A 利益率'))
        validList.push(this.validRate(this.fileData.planDataModel.planProfitRate3, 'planDataForm.planProfitRate3', '販社B 利益率'))
        validList.push(this.validRate(this.fileData.planDataModel.planProfitRate4, 'planDataForm.planProfitRate4', '販社C 利益率'))
        validList.push(this.validRate(this.fileData.planDataModel.planRegretRate1, 'planDataForm.planRegretRate1', '掛率C'))
        validList.push(this.validRate(this.fileData.planDataModel.planRegretRate2, 'planDataForm.planRegretRate2', '掛率B'))
        validList.push(this.validRate(this.fileData.planDataModel.planRegretRate3, 'planDataForm.planRegretRate3', '掛率A'))
        validList.push(this.validRate(this.fileData.planDataModel.planRegretRate4, 'planDataForm.planRegretRate4', '定価'))
        validList.push(this.validCost(this.fileData.planDataModel.planDeliveryCost, 'planDataForm.planDeliveryCost', '配送費'))
        validList.push(this.validCost(this.fileData.planDataModel.planExecutionCost, 'planDataForm.planExecutionCost', '組立設置費'))
      }
      validList.push(this.validContentsDataImgsSize())
      let isVarid = true
      validList.forEach(e => {
        if (!e) {
          isVarid = e
        }
      })
      if (!isVarid) {
        this.showValidationErrorModal()
        return
      }

      if (this.isPlan) {
        this.uRoomSize = {w: this.fileData.topSpaceModel.childrenSpaceModel[0].w, h: this.fileData.topSpaceModel.childrenSpaceModel[0].h, d: this.fileData.topSpaceModel.childrenSpaceModel[0].d}
      }
      /** ファイルデータ更新フォーム */
      let basicFileDataForm = {
        fileName: this.fileData.fileName,
        fileObjectType: this.objType,
        roomSize: this.isPlan ? this.uRoomSize : null,
        // maxRoomSize: this.maxRoomSize,
        // minRoomSize: this.minRoomSize,
        seriesNo: this.series.seriesNo,
        categoryNo: this.fileData.categoryNo,
        fileCode: this.fileData.fileCode,
        fileCaption: this.fileData.fileCaption,
        spaceJoincd: this.fileData.spaceJoincd,
        forceUpdate: this.forceUpdate,
        saveCheckFlg: true,
        updateFlg: false
      }
      let colorStyleForm = {
        colorStyleDefault: this.fileData.colorStyleDataModelList.length > 0 ? this.fileData.colorStyleDataModelList[0].colorStyleDefault : '',
        colorStyleGroup1: this.uColorStyleGrp[1],
        colorStyleGroup2: this.uColorStyleGrp[2],
        colorStyleGroup3: this.uColorStyleGrp[3],
        colorStyleGroup4: this.uColorStyleGrp[4],
        colorStyleGroup5: this.uColorStyleGrp[5],
        colorStyleGroup6: this.uColorStyleGrp[6],
        colorStyleGroup7: this.uColorStyleGrp[7],
        colorStyleGroup8: this.uColorStyleGrp[8],
        colorStyleGroup9: this.uColorStyleGrp[9],
        colorStyleGroup10: this.uColorStyleGrp[10],
        colorStyleDefaultStr: this.fileData.colorStyleDataModelList.length > 0 ? this.fileData.colorStyleDataModelList[0].colorStyleDefaultStr : '',
        colorStyleGroup1Str: this.uColorStyleGrpStr[1],
        colorStyleGroup2Str: this.uColorStyleGrpStr[2],
        colorStyleGroup3Str: this.uColorStyleGrpStr[3],
        colorStyleGroup4Str: this.uColorStyleGrpStr[4],
        colorStyleGroup5Str: this.uColorStyleGrpStr[5],
        colorStyleGroup6Str: this.uColorStyleGrpStr[6],
        colorStyleGroup7Str: this.uColorStyleGrpStr[7],
        colorStyleGroup8Str: this.uColorStyleGrpStr[8],
        colorStyleGroup9Str: this.uColorStyleGrpStr[9],
        colorStyleGroup10Str: this.uColorStyleGrpStr[10],
        colorStyleDefaultColor: this.fileData.colorStyleDataModelList.length > 0 ? this.fileData.colorStyleDataModelList[0].colorStyleDefaultColor : '',
        colorStyleGroup1Color: this.uColorStyleGrpColor[1],
        colorStyleGroup2Color: this.uColorStyleGrpColor[2],
        colorStyleGroup3Color: this.uColorStyleGrpColor[3],
        colorStyleGroup4Color: this.uColorStyleGrpColor[4],
        colorStyleGroup5Color: this.uColorStyleGrpColor[5],
        colorStyleGroup6Color: this.uColorStyleGrpColor[6],
        colorStyleGroup7Color: this.uColorStyleGrpColor[7],
        colorStyleGroup8Color: this.uColorStyleGrpColor[8],
        colorStyleGroup9Color: this.uColorStyleGrpColor[9],
        colorStyleGroup10Color: this.uColorStyleGrpColor[10]
      }
      let planDataForm = {
        planCount: this.fileData.planDataModel.planCount,
        // del 戻す 20230726 start
        // planRoomW: this.isPlan ? this.fileData.planDataModel.planRoomW : 0,
        // planRoomH: this.isPlan ? this.fileData.planDataModel.planRoomH : 0,
        // // planRoomD: this.isPlan ? this.fileData.planDataModel.planRoomD : 0,
        // planWallL: this.isPlan ? this.fileData.planDataModel.planWallL : 0,
        // planWallR: this.isPlan ? this.fileData.planDataModel.planWallR : 0,
        // del 戻す 20230726 end
        planSalesComment: this.fileData.planDataModel.planSalesComment,
        planPropertyName: this.isPlan ? this.fileData.planDataModel.planPropertyName : 'dummy',
        planBusinessId: this.fileData.planDataModel.planBusinessId,
        planDeliveryName: this.fileData.planDataModel.planDeliveryName,
        planDeliveryCountry: this.fileData.planDataModel.planDeliveryCountry,
        planDeliveryPostcd: this.fileData.planDataModel.planDeliveryPostcd,
        planDeliveryState: this.fileData.planDataModel.planDeliveryState,
        planDeliveryCity: this.fileData.planDataModel.planDeliveryCity,
        planDeliveryStreet: this.fileData.planDataModel.planDeliveryStreet,
        planDeliveryBuilding: this.fileData.planDataModel.planDeliveryBuilding,
        planDeliveryFloor: this.fileData.planDataModel.planDeliveryFloor,
        planDeliveryTel: this.fileData.planDataModel.planDeliveryTel,
        planDeliveryFax: this.fileData.planDataModel.planDeliveryFax,
        planDeliverryLastName: this.fileData.planDataModel.planDeliverryLastName,
        planDeliverryFirstName: this.fileData.planDataModel.planDeliverryFirstName,
        planDeliverryLastNameKana: this.fileData.planDataModel.planDeliverryLastNameKana,
        planDeliverryFirstNameKana: this.fileData.planDataModel.planDeliverryFirstNameKana,
        planDeliverryNotice: this.fileData.planDataModel.planDeliverryNotice,
        planEcInfoDeliPref1: this.fileData.planEcModel.ecInfoDeliPref1,
        planEcHealthCare: this.planEcHealthCare,
        // planLayerId: this.planLayer.planLayerId,
        planLayerName: this.planLayer.planLayerName,
        selectTime: this.selectTime,
        planEcInfoBtPref1: this.fileData.planEcModel.ecInfoBtPref1,
        planEcInfoBtPref2: this.fileData.planEcModel.ecInfoBtPref2,
        planEcInfoBtPref3: this.fileData.planEcModel.ecInfoBtPref3,
        planEstProbDisableFlg: this.fileData.planDataModel.planEstProbDisableFlg,
        planMaterialMagProb: this.isPlan ? this.innerHangingToDouble(this.fileData.planDataModel.planMaterialMagProb) : 0.0,
        planProcessCostMin: this.isPlan ? this.fileData.planDataModel.planProcessCostMin : 0,
        planProcessMagProb: this.isPlan ? this.innerHangingToDouble(this.fileData.planDataModel.planProcessMagProb) : 0.0,
        planProcessProfitProb: this.isPlan ? this.innerHangingToDouble(this.fileData.planDataModel.planProcessProfitProb) : 0.0,
        planFacttransCost: this.isPlan ? this.fileData.planDataModel.planFacttransCost : 0,
        // add DCD-464 20230912 start
        planExecutionCostPerson: this.isPlan ? this.fileData.planDataModel.planExecutionCostPerson : 0,
        planExecutionCostCar: this.isPlan ? this.fileData.planDataModel.planExecutionCostCar : 0,
        planExecutionCostMin: this.isPlan ? this.fileData.planDataModel.planExecutionCostMin : 0,
        planMobilizationCostPerson: this.isPlan ? this.fileData.planDataModel.planMobilizationCostPerson : 0,
        // add DCD-464 20230912 end
        planProfitRate1: this.isPlan ? this.hangingToDouble(this.fileData.planDataModel.planProfitRate1) : 1.0,
        planProfitRate2: this.isPlan ? this.hangingToDouble(this.fileData.planDataModel.planProfitRate2) : 1.0,
        planProfitRate3: this.isPlan ? this.hangingToDouble(this.fileData.planDataModel.planProfitRate3) : 1.0,
        planProfitRate4: this.isPlan ? this.hangingToDouble(this.fileData.planDataModel.planProfitRate4) : 1.0,
        planRegretRate1: this.isPlan ? this.fileData.planDataModel.planRegretRate1 / 100 : 1.0,
        planRegretRate2: this.isPlan ? this.fileData.planDataModel.planRegretRate2 / 100 : 1.0,
        planRegretRate3: this.isPlan ? this.fileData.planDataModel.planRegretRate3 / 100 : 1.0,
        planRegretRate4: this.isPlan ? this.fileData.planDataModel.planRegretRate4 / 100 : 1.0,
        planDeliveryCost: this.isPlan ? this.fileData.planDataModel.planDeliveryCost : 0,
        planExecutionCost: this.isPlan ? this.fileData.planDataModel.planExecutionCost : 0,
        planCustom1: this.uBusinessCustom[1],
        planCustom2: this.uBusinessCustom[2],
        planCustom3: this.uBusinessCustom[3],
        planCustom4: this.uBusinessCustom[4],
        planCustom5: this.uBusinessCustom[5],
        planCustom6: this.uBusinessCustom[6],
        planCustom7: this.uBusinessCustom[7],
        planCustom8: this.uBusinessCustom[8],
        planCustom9: this.uBusinessCustom[9],
        planCustom10: this.uBusinessCustom[10]
      }
      let setPlanCombineForm = {
        spaceJoincd: '',
        spaceIds: [],
        ratioDataList: [],
        minW: '',
        maxW: '',
        minH: '',
        maxH: '',
        minD: '',
        maxD: '',
        axisType: ''
      }
      let contentsDataForm = {}
      if (this.fileData.contentsDataModel != null) {
        contentsDataForm = {
          contentsDataId: this.fileData.contentsDataModel.contentsDataId,
          corpId: this.fileData.contentsDataModel.corpId,
          contentsType: this.fileData.contentsDataModel.contentsType,
          umCode: this.fileData.contentsDataModel.umCode,
          code: this.fileData.contentsDataModel.code,
          contentsPriority: this.fileData.contentsDataModel.contentsPriority,
          contentsTextShort: this.fileData.contentsDataModel.contentsTextShort,
          contentsTextLong: this.fileData.contentsDataModel.contentsTextLong,
          contentsImgBig: this.fileData.contentsDataModel.contentsImgBig,
          contentsImgMid: this.fileData.contentsDataModel.contentsImgMid,
          contentsImgSmall: this.fileData.contentsDataModel.contentsImgSmall,
          contentsImgConst1: this.fileData.contentsDataModel.contentsImgConst1,
          contentsImgConst2: this.fileData.contentsDataModel.contentsImgConst2,
          contentsImgConst3: this.fileData.contentsDataModel.contentsImgConst3,
          contentsRemark: this.fileData.contentsDataModel.contentsRemark,
          delFlg: this.fileData.contentsDataModel.delFlg
        }
      }

      let payload = new FormData()
      if (this.contentsDataUploadFile.big != null) {
        payload.append('contentsImgBig', new Blob([this.contentsDataUploadFile.big],
          {type: this.contentsDataUploadFile.big.type}), this.contentsDataUploadFile.big.name)
      }
      if (this.contentsDataUploadFile.mid != null) {
        payload.append('contentsImgMid', new Blob([this.contentsDataUploadFile.mid],
          {type: this.contentsDataUploadFile.mid.type}), this.contentsDataUploadFile.mid.name)
      }
      if (this.contentsDataUploadFile.small != null) {
        payload.append('contentsImgSmall', new Blob([this.contentsDataUploadFile.small],
          {type: this.contentsDataUploadFile.small.type}), this.contentsDataUploadFile.small.name)
      }
      if (this.contentsDataUploadFile.const1 != null) {
        payload.append('contentsImgConst1', new Blob([this.contentsDataUploadFile.const1],
          {type: this.contentsDataUploadFile.const1.type}), this.contentsDataUploadFile.const1.name)
      }
      if (this.contentsDataUploadFile.const2 != null) {
        payload.append('contentsImgConst2', new Blob([this.contentsDataUploadFile.const2],
          {type: this.contentsDataUploadFile.const2.type}), this.contentsDataUploadFile.const2.name)
      }
      if (this.contentsDataUploadFile.const3 != null) {
        payload.append('contentsImgConst3', new Blob([this.contentsDataUploadFile.const3],
          {type: this.contentsDataUploadFile.const3.type}), this.contentsDataUploadFile.const3.name)
      }
      payload.append('basicFileDataForm', JSON.stringify(basicFileDataForm))
      payload.append('colorStyleForm', JSON.stringify(colorStyleForm))
      payload.append('planDataForm', JSON.stringify(planDataForm))
      payload.append('setPlanCombineForm', JSON.stringify(setPlanCombineForm))
      payload.append('contentsDataForm', JSON.stringify(contentsDataForm))

      // // 掛け率を設定
      // if (this.planLayer != null) {
      //   payload.append('planProfitFormList', JSON.stringify(this.planProfitFormList))
      // }

      axios.post(API_URL.PLANNING + '/update', payload
      ).then(response => {
        this.modalDispIf = false
        App.showModal({
          messages: ['更新しました。'],
          onOk: () => {
            if (!this.forceUpdate) {
              // キャッシュの更新ならばファイルデータが返ってくるので適用
              this.$emit('setResponseData', response)
            }
            this.$emit('getAllFileList')
          }
        })
        Object.keys(this.contentsDataUploadFile).forEach(k => {
          this.contentsDataUploadFile[k] = null
        })
      }).catch(error => {
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        this.replaceErrorMessage(error)
        this.showValidationErrorModal()
      })
    },
    /**
     * ファイルデータの保存
     */
    saveAsFileData: function () {
      let validList = []
      if (this.isPlan) {
        // 数値入力のバリデーションチェック
        validList.push(this.validCount(this.fileData.planDataModel.planCount, 'planDataForm.planCount', '数量'))
        validList.push(this.validRate(this.fileData.planDataModel.planMaterialMagProb, 'planDataForm.planMaterialMagProb', '材料管理費率'))
        validList.push(this.validCost(this.fileData.planDataModel.planProcessCostMin, 'planDataForm.planProcessCostMin', '加工費 分レート'))
        validList.push(this.validRate(this.fileData.planDataModel.planProcessMagProb, 'planDataForm.planConstructplanProcess', '生産管理費率'))
        validList.push(this.validRate(this.fileData.planDataModel.planProcessProfitProb, 'planDataForm.planProcessProfitProb', '工場利益率'))
        validList.push(this.validCost(this.fileData.planDataModel.planFacttransCost, 'planDataForm.planFacttransCost', '輸送賃'))
        // add DCD-464 20230912 start
        validList.push(this.validCost(this.fileData.planDataModel.planExecutionCostPerson, 'planDataForm.planExecutionCostPerson', '施工人件費単価'))
        validList.push(this.validCost(this.fileData.planDataModel.planExecutionCostCar, 'planDataForm.planExecutionCostCar', '施工駐車場単価'))
        validList.push(this.validCost(this.fileData.planDataModel.planExecutionCostMin, 'planDataForm.planExecutionCostMin', '施工費最低保証金額'))
        validList.push(this.validCost(this.fileData.planDataModel.planMobilizationCostPerson, 'planDataForm.planMobilizationCostPerson', '搬入人件費単価'))
        // add DCD-464 20230912 end
        validList.push(this.validRate(this.fileData.planDataModel.planProfitRate1, 'planDataForm.planProfitRate1', '営業部門 利益率'))
        validList.push(this.validRate(this.fileData.planDataModel.planProfitRate2, 'planDataForm.planProfitRate2', '販社A 利益率'))
        validList.push(this.validRate(this.fileData.planDataModel.planProfitRate3, 'planDataForm.planProfitRate3', '販社B 利益率'))
        validList.push(this.validRate(this.fileData.planDataModel.planProfitRate4, 'planDataForm.planProfitRate4', '販社C 利益率'))
        validList.push(this.validRate(this.fileData.planDataModel.planRegretRate1, 'planDataForm.planRegretRate1', '掛率C'))
        validList.push(this.validRate(this.fileData.planDataModel.planRegretRate2, 'planDataForm.planRegretRate2', '掛率B'))
        validList.push(this.validRate(this.fileData.planDataModel.planRegretRate3, 'planDataForm.planRegretRate3', '掛率A'))
        validList.push(this.validRate(this.fileData.planDataModel.planRegretRate4, 'planDataForm.planRegretRate4', '定価'))
        validList.push(this.validCost(this.fileData.planDataModel.planDeliveryCost, 'planDataForm.planDeliveryCost', '配送費'))
        validList.push(this.validCost(this.fileData.planDataModel.planExecutionCost, 'planDataForm.planExecutionCost', '組立設置費'))
      }
      validList.push(this.validContentsDataImgsSize())
      let isVarid = true
      validList.forEach(e => {
        if (!e) {
          isVarid = e
        }
      })
      if (!isVarid) {
        this.showValidationErrorModal()
        return
      }

      let basicFileDataForm = {
        fileName: this.fileData.fileName,
        fileObjectType: this.objType,
        roomSize: this.isPlan ? this.uRoomSize : null,
        // maxRoomSize: this.maxRoomSize,
        // minRoomSize: this.minRoomSize,
        seriesNo: this.series.seriesNo,
        categoryNo: this.fileData.categoryNo,
        fileCode: this.fileData.fileCode,
        fileCaption: this.fileData.fileCaption,
        spaceJoincd: this.fileData.spaceJoincd,
        forceUpdate: this.forceUpdate,
        saveCheckFlg: true,
        updateFlg: false
      }

      // 先に重複チェック
      // if (this.isPlan || this.isSetPlan || this.isSetFix || this.isCombine) {
      if (this.isSetPlan || this.isSetFix || this.isCombine) {
        this.validateErrorMessages = {}
        axios.post(API_URL.PLANNING + '/check/existing-code', basicFileDataForm
        ).then(response => {
          if (response.data.data.isExisting) {
            if (response.data.data.isSameFileType) {
              App.showModal({
                messages: ['製品品番がすでに存在します。製品品番を変更した後、再度「保存」を押下してください。'],
                modalType: 'message',
                textAlign: 'left'
              })
            } else {
              App.showModal({
                title: 'エラー',
                messages: ['別のファイルタイプで既に使用している製品品番です。'],
                messageType: 'error'
              })
            }
          } else {
            this.saveAs(basicFileDataForm, false)
          }
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.replaceErrorMessage(error)
          this.showValidationErrorModal()
        })
      } else {
        this.saveAs(basicFileDataForm, false)
      }
    },
    saveAs: function (basicFileDataForm, updateFlg) {
      let colorStyleForm = {}
      if (this.isPlan) {
        this.uRoomSize = {w: this.fileData.topSpaceModel.childrenSpaceModel[0].w, h: this.fileData.topSpaceModel.childrenSpaceModel[0].h, d: this.fileData.topSpaceModel.childrenSpaceModel[0].d}
        colorStyleForm = {
          colorStyleDefault: this.fileData.colorStyleDataModelList[0].colorStyleDefault,
          colorStyleGroup1: this.uColorStyleGrp[1],
          colorStyleGroup2: this.uColorStyleGrp[2],
          colorStyleGroup3: this.uColorStyleGrp[3],
          colorStyleGroup4: this.uColorStyleGrp[4],
          colorStyleGroup5: this.uColorStyleGrp[5],
          colorStyleGroup6: this.uColorStyleGrp[6],
          colorStyleGroup7: this.uColorStyleGrp[7],
          colorStyleGroup8: this.uColorStyleGrp[8],
          colorStyleGroup9: this.uColorStyleGrp[9],
          colorStyleGroup10: this.uColorStyleGrp[10],
          colorStyleDefaultStr: this.fileData.colorStyleDataModelList[0].colorStyleDefaultStr,
          colorStyleGroup1Str: this.uColorStyleGrpStr[1],
          colorStyleGroup2Str: this.uColorStyleGrpStr[2],
          colorStyleGroup3Str: this.uColorStyleGrpStr[3],
          colorStyleGroup4Str: this.uColorStyleGrpStr[4],
          colorStyleGroup5Str: this.uColorStyleGrpStr[5],
          colorStyleGroup6Str: this.uColorStyleGrpStr[6],
          colorStyleGroup7Str: this.uColorStyleGrpStr[7],
          colorStyleGroup8Str: this.uColorStyleGrpStr[8],
          colorStyleGroup9Str: this.uColorStyleGrpStr[9],
          colorStyleGroup10Str: this.uColorStyleGrpStr[10],
          colorStyleDefaultColor: this.fileData.colorStyleDataModelList[0].colorStyleDefaultColor,
          colorStyleGroup1Color: this.uColorStyleGrpColor[1],
          colorStyleGroup2Color: this.uColorStyleGrpColor[2],
          colorStyleGroup3Color: this.uColorStyleGrpColor[3],
          colorStyleGroup4Color: this.uColorStyleGrpColor[4],
          colorStyleGroup5Color: this.uColorStyleGrpColor[5],
          colorStyleGroup6Color: this.uColorStyleGrpColor[6],
          colorStyleGroup7Color: this.uColorStyleGrpColor[7],
          colorStyleGroup8Color: this.uColorStyleGrpColor[8],
          colorStyleGroup9Color: this.uColorStyleGrpColor[9],
          colorStyleGroup10Color: this.uColorStyleGrpColor[10]
        }
      } else {
        colorStyleForm = {
          colorStyleDefault: this.colorStyleDefault,
          colorStyleGroup1: this.colorStyleGrp[1],
          colorStyleGroup2: this.colorStyleGrp[2],
          colorStyleGroup3: this.colorStyleGrp[3],
          colorStyleGroup4: this.colorStyleGrp[4],
          colorStyleGroup5: this.colorStyleGrp[5],
          colorStyleGroup6: this.colorStyleGrp[6],
          colorStyleGroup7: this.colorStyleGrp[7],
          colorStyleGroup8: this.colorStyleGrp[8],
          colorStyleGroup9: this.colorStyleGrp[9],
          colorStyleGroup10: this.colorStyleGrp[10],
          colorStyleDefaultStr: this.colorStyleDefaultStr,
          colorStyleGroup1Str: this.colorStyleGrpStr[1],
          colorStyleGroup2Str: this.colorStyleGrpStr[2],
          colorStyleGroup3Str: this.colorStyleGrpStr[3],
          colorStyleGroup4Str: this.colorStyleGrpStr[4],
          colorStyleGroup5Str: this.colorStyleGrpStr[5],
          colorStyleGroup6Str: this.colorStyleGrpStr[6],
          colorStyleGroup7Str: this.colorStyleGrpStr[7],
          colorStyleGroup8Str: this.colorStyleGrpStr[8],
          colorStyleGroup9Str: this.colorStyleGrpStr[9],
          colorStyleGroup10Str: this.colorStyleGrpStr[10],
          colorStyleDefaultColor: this.colorStyleDefaultColor,
          colorStyleGroup1Color: this.colorStyleGrpColor[1],
          colorStyleGroup2Color: this.colorStyleGrpColor[2],
          colorStyleGroup3Color: this.colorStyleGrpColor[3],
          colorStyleGroup4Color: this.colorStyleGrpColor[4],
          colorStyleGroup5Color: this.colorStyleGrpColor[5],
          colorStyleGroup6Color: this.colorStyleGrpColor[6],
          colorStyleGroup7Color: this.colorStyleGrpColor[7],
          colorStyleGroup8Color: this.colorStyleGrpColor[8],
          colorStyleGroup9Color: this.colorStyleGrpColor[9],
          colorStyleGroup10Color: this.colorStyleGrpColor[10]
        }
      }
      // 上書き更新フラグを設定
      basicFileDataForm.updateFlg = updateFlg
      let planDataForm = {
        planCount: this.fileData.planDataModel.planCount,
        // del 戻す 20230726 start
        // planRoomW: this.isPlan ? this.fileData.planDataModel.planRoomW : 0,
        // planRoomH: this.isPlan ? this.fileData.planDataModel.planRoomH : 0,
        // // planRoomD: this.isPlan ? this.fileData.planDataModel.planRoomD : 0,
        // planWallL: this.isPlan ? this.fileData.planDataModel.planWallL : 0,
        // planWallR: this.isPlan ? this.fileData.planDataModel.planWallR : 0,
        // del 戻す 20230726 end
        planSalesComment: this.fileData.planDataModel.planSalesComment,
        planPropertyName: this.isPlan ? this.fileData.planDataModel.planPropertyName : 'dummy',
        planBusinessId: this.fileData.planDataModel.planBusinessId,
        planDeliveryName: this.fileData.planDataModel.planDeliveryName,
        planDeliveryCountry: this.fileData.planDataModel.planDeliveryCountry,
        planDeliveryPostcd: this.fileData.planDataModel.planDeliveryPostcd,
        planDeliveryState: this.fileData.planDataModel.planDeliveryState,
        planDeliveryCity: this.fileData.planDataModel.planDeliveryCity,
        planDeliveryStreet: this.fileData.planDataModel.planDeliveryStreet,
        planDeliveryBuilding: this.fileData.planDataModel.planDeliveryBuilding,
        planDeliveryFloor: this.fileData.planDataModel.planDeliveryFloor,
        planDeliveryTel: this.fileData.planDataModel.planDeliveryTel,
        planDeliveryFax: this.fileData.planDataModel.planDeliveryFax,
        planDeliverryLastName: this.fileData.planDataModel.planDeliverryLastName,
        planDeliverryFirstName: this.fileData.planDataModel.planDeliverryFirstName,
        planDeliverryLastNameKana: this.fileData.planDataModel.planDeliverryLastNameKana,
        planDeliverryFirstNameKana: this.fileData.planDataModel.planDeliverryFirstNameKana,
        planDeliverryNotice: this.fileData.planDataModel.planDeliverryNotice,
        planEcInfoDeliPref1: this.fileData.planEcModel.ecInfoDeliPref1,
        planEcHealthCare: this.planEcHealthCare,
        planLayerId: this.planLayer.planLayerId,
        planLayerName: this.planLayer.planLayerName,
        selectTime: this.selectTime,
        planEcInfoBtPref1: this.fileData.planEcModel.ecInfoBtPref1,
        planEcInfoBtPref2: this.fileData.planEcModel.ecInfoBtPref2,
        planEcInfoBtPref3: this.fileData.planEcModel.ecInfoBtPref3,
        planEstProbDisableFlg: this.fileData.planDataModel.planEstProbDisableFlg,
        planMaterialMagProb: this.isPlan ? this.innerHangingToDouble(this.fileData.planDataModel.planMaterialMagProb) : 0.0,
        planProcessCostMin: this.isPlan ? this.fileData.planDataModel.planProcessCostMin : 0,
        planProcessMagProb: this.isPlan ? this.innerHangingToDouble(this.fileData.planDataModel.planProcessMagProb) : 0.0,
        planProcessProfitProb: this.isPlan ? this.innerHangingToDouble(this.fileData.planDataModel.planProcessProfitProb) : 0.0,
        planFacttransCost: this.isPlan ? this.fileData.planDataModel.planFacttransCost : 0,
        // add DCD-464 20230912 start
        planExecutionCostPerson: this.isPlan ? this.fileData.planDataModel.planExecutionCostPerson : 0,
        planExecutionCostCar: this.isPlan ? this.fileData.planDataModel.planExecutionCostCar : 0,
        planExecutionCostMin: this.isPlan ? this.fileData.planDataModel.planExecutionCostMin : 0,
        planMobilizationCostPerson: this.isPlan ? this.fileData.planDataModel.planMobilizationCostPerson : 0,
        // add DCD-464 20230912 end
        planProfitRate1: this.isPlan ? this.hangingToDouble(this.fileData.planDataModel.planProfitRate1) : 1.0,
        planProfitRate2: this.isPlan ? this.hangingToDouble(this.fileData.planDataModel.planProfitRate2) : 1.0,
        planProfitRate3: this.isPlan ? this.hangingToDouble(this.fileData.planDataModel.planProfitRate3) : 1.0,
        planProfitRate4: this.isPlan ? this.hangingToDouble(this.fileData.planDataModel.planProfitRate4) : 1.0,
        planRegretRate1: this.isPlan ? this.fileData.planDataModel.planRegretRate1 / 100 : 1.0,
        planRegretRate2: this.isPlan ? this.fileData.planDataModel.planRegretRate2 / 100 : 1.0,
        planRegretRate3: this.isPlan ? this.fileData.planDataModel.planRegretRate3 / 100 : 1.0,
        planRegretRate4: this.isPlan ? this.fileData.planDataModel.planRegretRate4 / 100 : 1.0,
        planDeliveryCost: this.isPlan ? this.fileData.planDataModel.planDeliveryCost : 0,
        planExecutionCost: this.isPlan ? this.fileData.planDataModel.planExecutionCost : 0,
        planCustom1: this.uBusinessCustom[1],
        planCustom2: this.uBusinessCustom[2],
        planCustom3: this.uBusinessCustom[3],
        planCustom4: this.uBusinessCustom[4],
        planCustom5: this.uBusinessCustom[5],
        planCustom6: this.uBusinessCustom[6],
        planCustom7: this.uBusinessCustom[7],
        planCustom8: this.uBusinessCustom[8],
        planCustom9: this.uBusinessCustom[9],
        planCustom10: this.uBusinessCustom[10]
      }
      let setPlanCombineForm = {
        spaceJoincd: '',
        spaceIds: [],
        ratioDataList: [],
        minW: '',
        maxW: '',
        minH: '',
        maxH: '',
        minD: '',
        maxD: '',
        axisType: ''
      }
      let contentsDataForm = {}
      if (this.fileData.contentsDataModel != null) {
        contentsDataForm = {
          contentsDataId: this.fileData.contentsDataModel.contentsDataId,
          corpId: this.fileData.contentsDataModel.corpId,
          contentsType: this.fileData.contentsDataModel.contentsType,
          umCode: this.fileData.contentsDataModel.umCode,
          code: this.fileData.contentsDataModel.code,
          contentsPriority: this.fileData.contentsDataModel.contentsPriority,
          contentsTextShort: this.fileData.contentsDataModel.contentsTextShort,
          contentsTextLong: this.fileData.contentsDataModel.contentsTextLong,
          contentsImgBig: this.fileData.contentsDataModel.contentsImgBig,
          contentsImgMid: this.fileData.contentsDataModel.contentsImgMid,
          contentsImgSmall: this.fileData.contentsDataModel.contentsImgSmall,
          contentsImgConst1: this.fileData.contentsDataModel.contentsImgConst1,
          contentsImgConst2: this.fileData.contentsDataModel.contentsImgConst2,
          contentsImgConst3: this.fileData.contentsDataModel.contentsImgConst3,
          contentsRemark: this.fileData.contentsDataModel.contentsRemark,
          delFlg: this.fileData.contentsDataModel.delFlg
        }
      }

      let payload = new FormData()
      if (this.contentsDataUploadFile.big != null) {
        payload.append('contentsImgBig', new Blob([this.contentsDataUploadFile.big],
          {type: this.contentsDataUploadFile.big.type}), this.contentsDataUploadFile.big.name)
      }
      if (this.contentsDataUploadFile.mid != null) {
        payload.append('contentsImgMid', new Blob([this.contentsDataUploadFile.mid],
          {type: this.contentsDataUploadFile.mid.type}), this.contentsDataUploadFile.mid.name)
      }
      if (this.contentsDataUploadFile.small != null) {
        payload.append('contentsImgSmall', new Blob([this.contentsDataUploadFile.small],
          {type: this.contentsDataUploadFile.small.type}), this.contentsDataUploadFile.small.name)
      }
      if (this.contentsDataUploadFile.const1 != null) {
        payload.append('contentsImgConst1', new Blob([this.contentsDataUploadFile.const1],
          {type: this.contentsDataUploadFile.const1.type}), this.contentsDataUploadFile.const1.name)
      }
      if (this.contentsDataUploadFile.const2 != null) {
        payload.append('contentsImgConst2', new Blob([this.contentsDataUploadFile.const2],
          {type: this.contentsDataUploadFile.const2.type}), this.contentsDataUploadFile.const2.name)
      }
      if (this.contentsDataUploadFile.const3 != null) {
        payload.append('contentsImgConst3', new Blob([this.contentsDataUploadFile.const3],
          {type: this.contentsDataUploadFile.const3.type}), this.contentsDataUploadFile.const3.name)
      }
      payload.append('basicFileDataForm', JSON.stringify(basicFileDataForm))
      payload.append('colorStyleForm', JSON.stringify(colorStyleForm))
      payload.append('planDataForm', JSON.stringify(planDataForm))
      payload.append('setPlanCombineForm', JSON.stringify(setPlanCombineForm))
      payload.append('contentsDataForm', JSON.stringify(contentsDataForm))

      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/save-as', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            if (Object.keys(response.data.validationErrors).length > 0) {
              this.errorMessage.text = response.data.errorMessage
            } else {
              App.showModal({
                title: 'エラー',
                messages: [response.data.errorMessage],
                messageType: 'error'
              })
            }
          } else {
            this.modalDispIf = false
            this.$emit('setResponseData', response)
            this.$emit('setSectionPosition', true)
            this.$emit('clearSpaceTreeFlg')
            this.$emit('closeSelectSpaceModal')
            this.$emit('closeSelectUpdateInsertModal')
            App.showModal({
              messages: ['保存しました。'],
              onOk: () => {
                this.$emit('getAllFileList')
              }
            })
            this.contentsDataUploadFile.big = null
            this.contentsDataUploadFile.mid = null
            this.contentsDataUploadFile.small = null
            this.contentsDataUploadFile.const1 = null
            this.contentsDataUploadFile.const2 = null
            this.contentsDataUploadFile.const3 = null
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.replaceErrorMessage(error)
          this.showValidationErrorModal()
        })
    },
    // *****************************************************************
    // コンテンツデータの登録
    // *****************************************************************
    registerContentsData: function () {
      let contentsDataForm = {
        contentsDataId: this.fileData.contentsDataModel.contentsDataId,
        corpId: this.fileData.corpId,
        contentsType: this.fileData.contentsDataModel.contentsType,
        umCode: this.fileData.fileCode,
        code: this.fileData.contentsDataModel.code,
        contentsPriority: this.fileData.contentsDataModel.contentsPriority,
        contentsTextShort: this.fileData.contentsDataModel.contentsTextShort,
        contentsTextLong: this.fileData.contentsDataModel.contentsTextLong,
        contentsImgBig: this.fileData.contentsDataModel.contentsImgBig,
        contentsImgMid: this.fileData.contentsDataModel.contentsImgMid,
        contentsImgSmall: this.fileData.contentsDataModel.contentsImgSmall,
        contentsImgConst1: this.fileData.contentsDataModel.contentsImgConst1,
        contentsImgConst2: this.fileData.contentsDataModel.contentsImgConst2,
        contentsImgConst3: this.fileData.contentsDataModel.contentsImgConst3,
        contentsRemark: this.fileData.contentsDataModel.contentsRemark,
        delFlg: this.fileData.contentsDataModel.delFlg
      }

      let payload = new FormData()
      if (this.contentsDataUploadFile.big != null) {
        payload.append('contentsImgBig', new Blob([this.contentsDataUploadFile.big],
          {type: this.contentsDataUploadFile.big.type}), this.contentsDataUploadFile.big.name)
      }
      if (this.contentsDataUploadFile.mid != null) {
        payload.append('contentsImgMid', new Blob([this.contentsDataUploadFile.mid],
          {type: this.contentsDataUploadFile.mid.type}), this.contentsDataUploadFile.mid.name)
      }
      if (this.contentsDataUploadFile.small != null) {
        payload.append('contentsImgSmall', new Blob([this.contentsDataUploadFile.small],
          {type: this.contentsDataUploadFile.small.type}), this.contentsDataUploadFile.small.name)
      }
      if (this.contentsDataUploadFile.const1 != null) {
        payload.append('contentsImgConst1', new Blob([this.contentsDataUploadFile.const1],
          {type: this.contentsDataUploadFile.const1.type}), this.contentsDataUploadFile.const1.name)
      }
      if (this.contentsDataUploadFile.const2 != null) {
        payload.append('contentsImgConst2', new Blob([this.contentsDataUploadFile.const2],
          {type: this.contentsDataUploadFile.const2.type}), this.contentsDataUploadFile.const2.name)
      }
      if (this.contentsDataUploadFile.const3 != null) {
        payload.append('contentsImgConst3', new Blob([this.contentsDataUploadFile.const3],
          {type: this.contentsDataUploadFile.const3.type}), this.contentsDataUploadFile.const3.name)
      }
      payload.append('contentsDataForm', JSON.stringify(contentsDataForm))

      axios.post(API_URL.CONTENTS_DATA + '/register', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            if (Object.keys(response.data.validationErrors).length > 0) {
              this.errorMessage.text = response.data.errorMessage
            } else {
              App.showModal({
                title: 'エラー',
                messages: [response.data.errorMessage],
                messageType: 'error'
              })
            }
          } else {
            this.modalDispIf = false
            this.$emit('setResponseData', response)
            this.$emit('setSectionPosition', true)
            this.$emit('clearSpaceTreeFlg')
            this.$emit('closeSelectSpaceModal')
            this.$emit('closeSelectUpdateInsertModal')
            App.showModal({
              messages: ['保存しました。'],
              onOk: () => {
                this.$emit('getAllFileList')
              }
            })
            Object.keys(this.contentsDataUploadFile).forEach(k => {
              this.contentsDataUploadFile[k] = null
            })
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.replaceErrorMessage(error)
          this.showValidationErrorModal()
        })
    },
    // *****************************************************************
    // ルール付きセットプラン用
    // *****************************************************************
    /** ルール付きセットプランの初期情報を取得 */
    setRuledData: function (spaceIds, axisType) {
      if (axisType === AXIS_TYPE.UNDEFINED) return
      this.ruledSpaceList = spaceIds.map(id => {
        return SpaceUtil.getGlobalSpace(id, this.globalSpaceMap)
      })
      this.ruledAxisType = axisType
      // 比率の計算 // move to:bugfix:DCD-459 20230628
      this.calcSpaceRatio(this.ruledSpaceList)
      // 最大値・最小値の設定
      this.setRuledMaxMin(this.ruledSpaceList)
      this.ruledSpaceList.forEach((space, idx) => {
        if (space.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_COUNTER.code) {
          this.ruledSetPlanFix[idx] = true
        } else {
          this.ruledSetPlanFix[idx] = false
        }
      })
      // // 比率の計算 // move from:bugfix:DCD-459 20230628
      // this.calcSpaceRatio(this.ruledSpaceList)
      // 比率設定方向の情報を設定
      switch (this.ruledAxisType) {
        case AXIS_TYPE.X:
          this.ruledSetData.firstText = '左'
          this.ruledSetData.secondText = '右'
          this.ruledSetData.sizeText = 'W'
          break
        case AXIS_TYPE.Y:
          this.ruledSetData.firstText = '上'
          this.ruledSetData.secondText = '下'
          this.ruledSetData.sizeText = 'H'
          break
        case AXIS_TYPE.Z:
          this.ruledSetData.firstText = '前'
          this.ruledSetData.secondText = '後'
          this.ruledSetData.sizeText = 'D'
          break
        default:
      }
    },
    /** ルール付きセットプランの最大・最小値を取得 */
    setRuledMaxMin: function (spaceList) {
      this.ruledSetMinW = null
      this.ruledSetMaxW = null
      this.ruledSetMinH = null
      this.ruledSetMaxH = null
      this.ruledSetMinD = null
      this.ruledSetMaxD = null
      let counter = spaceList.find(space => space.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_COUNTER.code)
      let nextSpace = null
      let emptyDistTotal = 0 // 空き空間の距離の合計 add DCD-459 20230629
      spaceList.forEach((space, idx) => {
        // 空き空間の距離
        let emptyDist = 0
        // 固定設定フラグ
        let fixFlg = this.ruledSetPlanFix[idx]
        let minW = space.limitMinW !== null ? space.limitMinW : space.minW !== null ? space.minW : null
        let maxW = space.limitMaxW !== null ? space.limitMaxW : space.maxW !== null ? space.maxW : null
        let minH = space.limitMinH !== null ? space.limitMinH : space.minH !== null ? space.minH : null
        let maxH = space.limitMaxH !== null ? space.limitMaxH : space.maxH !== null ? space.maxH : null
        let minD = space.limitMinD !== null ? space.limitMinD : space.minD !== null ? space.minD : null
        let maxD = space.limitMaxD !== null ? space.limitMaxD : space.maxD !== null ? space.maxD : null
        switch (this.ruledAxisType) {
          case AXIS_TYPE.X:
            if (fixFlg) {
              minW = space.w
              maxW = space.w
            }
            // 隣の空間との距離を更新
            if (nextSpace != null) {
              emptyDist = Math.abs(FaceUtil.getFaceDistance(nextSpace, FACE_TYPE.RIGHT, space, FACE_TYPE.LEFT))
            }
            this.ruledSetMinH = this.ruledSetMinH !== null && this.ruledSetMinH > minH ? this.ruledSetMinH : minH
            this.ruledSetMaxH = this.ruledSetMaxH !== null && this.ruledSetMaxH < maxH ? this.ruledSetMaxH : maxH
            this.ruledSetMinD = this.ruledSetMinD !== null && this.ruledSetMinD > minD ? this.ruledSetMinD : minD
            this.ruledSetMaxD = this.ruledSetMaxD !== null && this.ruledSetMaxD < maxD ? this.ruledSetMaxD : maxD
            // mdf DCD-459 20230629 start
            // this.ruledSetMinW = this.ruledSetMinW !== null ? this.ruledSetMinW + minW + emptyDist : minW
            // this.ruledSetMaxW = this.ruledSetMaxW !== null ? this.ruledSetMaxW + maxW + emptyDist : maxW
            emptyDistTotal += emptyDist
            // mdf DCD-459 20230629 end
            this.axisType = 1
            break
          case AXIS_TYPE.Y:
            if (fixFlg) {
              minH = space.h
              maxH = space.h
            }
            // Y方向ルールだけカウンター飛び出し分を調整
            if (space.spaceObjectDtlType !== OBJECT_DTL_TYPE.UNIT_COUNTER.code) {
              minW = minW + this.getCounterLedge(space, counter, AXIS_TYPE.X)
              maxW = maxW + this.getCounterLedge(space, counter, AXIS_TYPE.X)
              minD = minD + this.getCounterLedge(space, counter, AXIS_TYPE.Z)
              maxD = maxD + this.getCounterLedge(space, counter, AXIS_TYPE.Z)
            }
            // 隣の空間との距離を更新
            if (nextSpace != null) {
              emptyDist = Math.abs(FaceUtil.getFaceDistance(nextSpace, FACE_TYPE.BOTTOM, space, FACE_TYPE.TOP))
            }
            this.ruledSetMinW = this.ruledSetMinW !== null && this.ruledSetMinW > minW ? this.ruledSetMinW : minW
            this.ruledSetMaxW = this.ruledSetMaxW !== null && this.ruledSetMaxW < maxW ? this.ruledSetMaxW : maxW
            this.ruledSetMinD = this.ruledSetMinD !== null && this.ruledSetMinD > minD ? this.ruledSetMinD : minD
            this.ruledSetMaxD = this.ruledSetMaxD !== null && this.ruledSetMaxD < maxD ? this.ruledSetMaxD : maxD
            // mdf DCD-459 20230629 start
            // this.ruledSetMinH = this.ruledSetMinH !== null ? this.ruledSetMinH + minH + emptyDist : minH
            // this.ruledSetMaxH = this.ruledSetMaxH !== null ? this.ruledSetMaxH + maxH + emptyDist : maxH
            emptyDistTotal += emptyDist
            // mdf DCD-459 20230629 end
            this.axisType = 0
            break
          case AXIS_TYPE.Z:
            if (fixFlg) {
              minD = space.d
              maxD = space.d
            }
            // 隣の空間との距離を更新
            if (nextSpace != null) {
              emptyDist = Math.abs(FaceUtil.getFaceDistance(nextSpace, FACE_TYPE.BACK, space, FACE_TYPE.FRONT))
            }
            this.ruledSetMinW = this.ruledSetMinW !== null && this.ruledSetMinW > minW ? this.ruledSetMinW : minW
            this.ruledSetMaxW = this.ruledSetMaxW !== null && this.ruledSetMaxW < maxW ? this.ruledSetMaxW : maxW
            this.ruledSetMinH = this.ruledSetMinH !== null && this.ruledSetMinH > minH ? this.ruledSetMinH : minH
            this.ruledSetMaxH = this.ruledSetMaxH !== null && this.ruledSetMaxH < maxH ? this.ruledSetMaxH : maxH
            // mdf DCD-459 20230629 start
            // this.ruledSetMinD = this.ruledSetMinD !== null ? this.ruledSetMinD + minD + emptyDist : minD
            // this.ruledSetMaxD = this.ruledSetMaxD !== null ? this.ruledSetMaxD + maxD + emptyDist : maxD
            emptyDistTotal += emptyDist
            // mdf DCD-459 20230629 end
            this.axisType = 2
            break
          default:
        }
        nextSpace = space
      })
      // add DCD-459 20230629 start
      let basicMinSize = 0 // 基準比率空間の最小サイズ
      let basicMaxSize = 999999 // 基準比率空間の最大サイズ
      let basicMinRatio = 0 // 最小時の基準比率空間の比率
      let basicMaxRatio = 0 // 最大時の基準比率空間の比率
      // 空間リストの全件について以下の処理を実行する
      for (let i = 0; i < spaceList.length; i++) {
        if (this.ruledSetPlanFix[i]) { // 固定値は飛ばす
          continue
        }
        let spaceA = spaceList[i]
        let minA = this.getSpaceMin(spaceA)
        let maxA = this.getSpaceMax(spaceA)
        let ratioA = this.ruledSetPlanRatio[i]
        if (ratioA === 0) { // 0割回避
          continue
        }
        // 最小値を検索：空間リストの全件について以下の処理を実行する
        let foundMin = true
        for (let j = 0; j < spaceList.length; j++) {
          if (this.ruledSetPlanFix[j]) { // 固定値は飛ばす
            continue
          }
          let spaceB = spaceList[j]
          let minB = this.getSpaceMin(spaceB)
          let maxB = this.getSpaceMax(spaceB)
          let ratioB = this.ruledSetPlanRatio[j]
          // Aが最小サイズの時のBのサイズを求める
          let sizeB = minA * ratioB / ratioA
          // このサイズが最小最大の範囲からはみ出すならば、不採用
          if (sizeB < minB || sizeB > maxB) {
            foundMin = false
            break
          }
        }
        if (foundMin && basicMinSize < minA) {
          basicMinSize = minA
          basicMinRatio = ratioA
        }
        // 最大値を検索：空間リストの全件について以下の処理を実行する
        let foundMax = true
        for (let j = 0; j < spaceList.length; j++) {
          if (this.ruledSetPlanFix[j]) { // 固定値は飛ばす
            continue
          }
          let spaceB = spaceList[j]
          let minB = this.getSpaceMin(spaceB)
          let maxB = this.getSpaceMax(spaceB)
          let ratioB = this.ruledSetPlanRatio[j]
          // Aが最大サイズの時のBのサイズを求める
          let sizeB = maxA * ratioB / ratioA
          // このサイズが最小最大の範囲からはみ出すならば、不採用
          if (sizeB < minB || sizeB > maxB) {
            foundMax = false
            break
          }
        }
        if (foundMax && basicMaxSize > maxA) {
          basicMaxSize = maxA
          basicMaxRatio = ratioA
        }
      }
      // 基準となる最小最大値が求まったら、改めて各ユニットの比率に応じた最小最大値を算出して合算する
      let totalMinSize = 0
      let totalMaxSize = 0
      for (let i = 0; i < spaceList.length; i++) {
        let space = spaceList[i]
        let ratio = this.ruledSetPlanRatio[i]
        if (this.ruledSetPlanFix[i]) { // 固定値
          totalMinSize += this.getSpaceSize(space)
          totalMaxSize += this.getSpaceSize(space)
        } else {
          let minSizeByRatio = basicMinSize * ratio / basicMinRatio
          totalMinSize += minSizeByRatio
          let maxSizeByRatio = basicMaxSize * ratio / basicMaxRatio
          totalMaxSize += maxSizeByRatio
        }
      }
      // 隙間合計を全ユニットの最小値合計に合算する
      totalMinSize += emptyDistTotal
      totalMaxSize += emptyDistTotal
      // メンバ変数にセットする
      this.setRuledSetMin(CalcUtil.round(totalMinSize))
      this.setRuledSetMax(CalcUtil.round(totalMaxSize))
      // add DCD-459 20230629 end
    },
    // add DCD-459 20230629 start
    getSpaceMin: function (space) {
      let orgMin = 0
      if (this.ruledAxisType === AXIS_TYPE.X) {
        orgMin = space.limitMinW !== null ? space.limitMinW : space.minW !== null ? space.minW : null
      } else if (this.ruledAxisType === AXIS_TYPE.Y) {
        orgMin = space.limitMinH !== null ? space.limitMinH : space.minH !== null ? space.minH : null
      } else {
        orgMin = space.limitMinD !== null ? space.limitMinD : space.minD !== null ? space.minD : null
      }
      return orgMin
    },
    getSpaceMax: function (space) {
      let orgMax = 0
      if (this.ruledAxisType === AXIS_TYPE.X) {
        orgMax = space.limitMaxW !== null ? space.limitMaxW : space.maxW !== null ? space.maxW : null
      } else if (this.ruledAxisType === AXIS_TYPE.Y) {
        orgMax = space.limitMaxH !== null ? space.limitMaxH : space.maxH !== null ? space.maxH : null
      } else {
        orgMax = space.limitMaxD !== null ? space.limitMaxD : space.maxD !== null ? space.maxD : null
      }
      return orgMax
    },
    getSpaceSize: function (space) {
      if (this.ruledAxisType === AXIS_TYPE.X) {
        return space.w
      } else if (this.ruledAxisType === AXIS_TYPE.Y) {
        return space.h
      } else {
        return space.d
      }
    },
    setRuledSetMin: function (totalMinSize) {
      if (this.ruledAxisType === AXIS_TYPE.X) {
        this.ruledSetMinW = totalMinSize
      } else if (this.ruledAxisType === AXIS_TYPE.Y) {
        this.ruledSetMinH = totalMinSize
      } else {
        this.ruledSetMinD = totalMinSize
      }
    },
    setRuledSetMax: function (totalMaxSize) {
      if (this.ruledAxisType === AXIS_TYPE.X) {
        this.ruledSetMaxW = totalMaxSize
      } else if (this.ruledAxisType === AXIS_TYPE.Y) {
        this.ruledSetMaxH = totalMaxSize
      } else {
        this.ruledSetMaxD = totalMaxSize
      }
    },
    // add DCD-459 20230629 end
    getCounterLedge: function (space, counter, minMaxType) {
      if (!counter) return 0
      switch (minMaxType) {
        case AXIS_TYPE.X:
          return counter.w - space.w
        case AXIS_TYPE.Y:
          return counter.h - space.h
        case AXIS_TYPE.Z:
          return counter.d - space.d
      }
    },
    // 比率の初期値を計算
    calcSpaceRatio: function (spaceList) {
      let totalRatio = 1
      let totalSize = 0
      // サイズ合計の計算
      spaceList.filter((space, idx) => !this.ruledSetPlanFix[idx])
        .forEach(space => {
          if (this.ruledAxisType === AXIS_TYPE.X) {
            totalSize += space.w
          } else if (this.ruledAxisType === AXIS_TYPE.Y) {
            totalSize += space.h
          } else if (this.ruledAxisType === AXIS_TYPE.Z) {
            totalSize += space.d
          }
        })
      let firstRatio = 0
      spaceList.forEach((space, idx) => {
        let fixFlg = this.ruledSetPlanFix[idx]
        if (!fixFlg) {
          let size = 0
          if (this.ruledAxisType === AXIS_TYPE.X) {
            size = space.w
          } else if (this.ruledAxisType === AXIS_TYPE.Y) {
            size = space.h
          } else if (this.ruledAxisType === AXIS_TYPE.Z) {
            size = space.d
          }
          let ratio = size / totalSize * totalRatio
          if (firstRatio === 0) {
            firstRatio = ratio
          }
          // 正規化
          ratio = CalcUtil.round(ratio / firstRatio)
          this.ruledSetPlanRatio[idx] = ratio
        } else {
          this.ruledSetPlanRatio[idx] = ''
        }
      })
    },
    checkFixSpace: function (id) {
      let targetSpace = this.ruledSpaceList.find(space => space.id === id)
      return targetSpace.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_COUNTER.code
    },
    // *****************************************************************
    // バリデーション・表記変換
    // *****************************************************************
    replaceErrorMessage: function (error) {
      // fileNameのエラーメッセージは、”ファイル名”と設定されて戻ってくるので、getTypeNameで置換する。
      if (typeof this.validateErrorMessages['basicFileDataForm.fileName'] !== 'undefined') {
        this.validateErrorMessages['basicFileDataForm.fileName'] = this.validateErrorMessages['basicFileDataForm.fileName'].replace('ファイル', this.getTypeName)
      }

      // カスタムバリデーションを設定
      if (error.response.data.validationErrors != null) {
        let validationErrors = error.response.data.validationErrors
        if (validationErrors.CustomConstraint != null) {
          for (let i = 0; i <= validationErrors.CustomConstraint.length; i++) {
            this.validateErrorMessages['CustomConstraint' + i] = validationErrors.CustomConstraint[i]
          }
          delete this.validateErrorMessages['CustomConstraint']
        }
      }
    },
    /** 内掛けの掛率をdouble型表記から％表記に変換 */
    innerHangingToPercent: function (prob) {
      return Math.round((prob - 1) * 100)
    },
    /** 内掛けの掛率を%表記からdouble型表記に変換 */
    innerHangingToDouble: function (prob) {
      if (prob == null || prob === '') return prob
      return 1 + prob / 100
    },
    /** 外掛けの掛率をdouble型表記から％表記に変換 */
    hangingToPercent: function (prob) {
      return Math.round((1 - prob) * 100)
    },
    /** 外掛けの掛率を%表記からdouble型表記に変換 */
    hangingToDouble: function (prob) {
      if (prob == null || prob === '') return prob
      // return 1 - prob / 100 // mdf DCD-463 20230829
      let num = 1 - prob / 100
      return num.toFixed(2)
    },
    /** 数量のバリデーションチェック（入力した値が0以上99以下であるか判定） */
    validCount: function (planCount, key, errorMessage) {
      let pattern = /^([1-9]\d*|0)$/
      if (planCount !== null && planCount !== '' && (!pattern.test(planCount) || String(planCount).length > 2)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は0以上99以下の整数で入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    /** 掛率のバリデーションチェック（入力した値が0以上999以下であるか判定） */
    validRate: function (executionRate, key, errorMessage) {
      let pattern = /^([1-9]\d*|0)$/
      if (executionRate !== null && executionRate !== '' && (!pattern.test(executionRate) || String(executionRate).length > 3)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は0以上999以下の整数で入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    /** 価格のバリデーションチェック（入力した値が整数であるか判定） */
    validCost: function (executionCost, key, errorMessage) {
      let pattern = /^([1-9]\d*|0)$/
      if (executionCost !== null && executionCost !== '' && (!pattern.test(executionCost) || String(executionCost).length > 9)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は0以上999999999以下の整数で入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    /** 最小値・最大値のバリデーションチェック */
    validMinMax: function (minMaxList, key) {
      if (minMaxList !== null && minMaxList !== '') {
        let valid = true
        minMaxList.forEach(value => {
          if (value === null || value === '') {
            this.$set(this.validateErrorMessages, key, '最小値・最大値は必須です。')
            valid = false
          }
        })
        return valid
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    /** コンテンツデータの画像のアップロードの合計ファイルサイズの上限チェック */
    validContentsDataImgsSize: function () {
      let valid = true
      let filesSize = 0
      Object.keys(this.contentsDataUploadFile).forEach(k => {
        let file = this.contentsDataUploadFile[k]
        if (file != null) filesSize += file.size
      })

      if (filesSize > this.maxFileSize) {
        this.$set(this.validateErrorMessages, 'maxFileSize', 'アップロードする画像のサイズの合計が上限より' + CalcUtil.convertByte(filesSize - this.maxFileSize) + '大きいです。')
        valid = false
      }
      return valid
    },
    showValidationErrorModal: function () {
      App.showModal({
        title: 'エラー',
        messages: Object.values(this.validateErrorMessages),
        messageType: 'error',
        textAlign: 'left'
      })
    },
    // *****************************************************************
    // コンテンツデータ
    // *****************************************************************
    getMaxFileSize: function () {
      axios.get(API_URL.CONTENTS_DATA + '/getmaxfilesize'
      ).then(response => {
        if (response.data.errorMessage) {
          let modalData = {
            title: 'ファイルの最大サイズの取得に失敗しました。',
            messages: response.data.errorMessage.split(/\r?\n/g),
            messageType: 'error'
          }
          App.showModal(modalData)
        } else {
          this.maxFileSize = response.data.data
        }
      }).catch(error => {
        Api.handleError(error)
      })
    },
    fileChangeImgBig: function (event) {
      this.contentsDataUploadFile.big = event.target.files[0]
    },
    fileChangeImgMid: function (event) {
      this.contentsDataUploadFile.mid = event.target.files[0]
    },
    fileChangeImgSmall: function (event) {
      this.contentsDataUploadFile.small = event.target.files[0]
    },
    fileChangeImgConst1: function (event) {
      this.contentsDataUploadFile.const1 = event.target.files[0]
    },
    fileChangeImgConst2: function (event) {
      this.contentsDataUploadFile.const2 = event.target.files[0]
    },
    fileChangeImgConst3: function (event) {
      this.contentsDataUploadFile.const3 = event.target.files[0]
    },
    getContentsImg: function (key, key2) {
      if (this.contentsDataUploadFile[key] != null) {
        return URL.createObjectURL(this.contentsDataUploadFile[key])
      }
      if (this.isEdit && this.fileData && Object.keys(this.fileData).length > 0 && this.fileData.contentsDataModel[key2]) {
        return App.getContentsResource(this.fileData.corpId + '/' + this.fileData.contentsDataModel[key2])
      }
      return App.getDarosResource('noimage.svg')
    },
    noImage: function (element) {
      element.target.src = App.getDarosResource('noimage.svg')
    },
    // *****************************************************************
    // その他
    // *****************************************************************
    /** タブクリック */
    onClickTab: function (param) {
      this.isActive = param
    },
    /** データの初期化 */
    clearCache: function () {
      // 入力データクリア
      this.isActive = 0
      this.planPropertyName = ''
      this.name = ''
      this.roomSize = {w: 2500, h: 2400, d: 2500}
      this.maxRoomSize = {w: '', h: '', d: ''}
      this.minRoomSize = {w: '', h: '', d: ''}
      // this.categoryNo = ''
      this.categoryNo = this.categoryList[0].categoryNo
      this.fileCode = ''
      this.planCount = 1
      // del 戻す 20230726 start
      // this.planRoomW = 2500
      // this.planRoomH = 2400
      // // this.planRoomD = 2500
      // this.planWallL = 0
      // this.planWallR = 0
      // del 戻す 20230726 end
      this.planSalesComment = ''
      this.fileCaption = ''
      this.saveCheckFlg = false
      // TODO 初期値検討の余地ありdefault～10
      this.colorStyleDefault = this.colorMaterialList[0].colorMaterialId
      this.colorStyleGrp = {
        1: this.colorStyleTypeList[1] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[1]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[1]).colorMaterialId : '',
        2: this.colorStyleTypeList[2] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[2]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[2]).colorMaterialId : '',
        3: this.colorStyleTypeList[3] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[3]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[3]).colorMaterialId : '',
        4: this.colorStyleTypeList[4] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[4]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[4]).colorMaterialId : '',
        5: this.colorStyleTypeList[5] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[5]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[5]).colorMaterialId : '',
        6: this.colorStyleTypeList[6] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[6]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[6]).colorMaterialId : '',
        7: this.colorStyleTypeList[7] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[7]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[7]).colorMaterialId : '',
        8: this.colorStyleTypeList[8] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[8]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[8]).colorMaterialId : '',
        9: this.colorStyleTypeList[9] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[9]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[9]).colorMaterialId : '',
        10: this.colorStyleTypeList[10] && this.colorMaterialList.some(e => e.colorMaterialType === this.colorStyleTypeList[10]) ? this.colorMaterialList.find(e => e.colorMaterialType === this.colorStyleTypeList[10]).colorMaterialId : ''
      }
      this.businessId = ''
      this.selectedBusiness = {}
      this.businessCustom = {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''}
      this.planDeliveryName = ''
      this.planDeliveryCountry = ''
      this.planDeliveryPostcd = ''
      this.planDeliveryState = ''
      this.planDeliveryCity = ''
      this.planDeliveryStreet = ''
      this.planDeliveryBuilding = ''
      this.planDeliveryFloor = ''
      this.planDeliveryTel = ''
      this.planDeliveryFax = ''
      this.planDeliveryLastName = ''
      this.planDeliveryFirstName = ''
      this.planDeliveryLastNameKana = ''
      this.planDeliveryFirstNameKana = ''
      this.planDeliveryNotice = ''
      this.planEcInfoDeliPref1 = ''
      this.planEcHealthCare = 0
      this.planLayer = {}
      this.selectTime = ''
      this.planEcInfoBtPref1 = ''
      this.planEcInfoBtPref2 = ''
      this.planEcInfoBtPref3 = ''
      this.planEstProbDisableFlg = false
      this.planMaterialMagProb = ''
      this.planProcessCostMin = ''
      this.planProcessMagProb = ''
      this.planProcessProfitProb = ''
      this.planFacttransCost = ''
      // add DCD-464 20230912 start
      this.planExecutionCostPerson = ''
      this.planExecutionCostCar = ''
      this.planExecutionCostMin = ''
      this.planMobilizationCostPerson = ''
      // add DCD-464 20230912 end
      this.planProfitRate1 = ''
      this.planProfitRate2 = ''
      this.planProfitRate3 = ''
      this.planProfitRate4 = ''
      this.planDeliveryCost = ''
      this.planExecutionCost = ''
      this.srcSpaceJoincd = ''
      this.srcSpaceIds = []
      this.ruledSetPlanRatio = []
      this.ruledSetPlanFix = []
      this.ruledSetMinW = ''
      this.ruledSetMinH = ''
      this.ruledSetMinD = ''
      this.ruledSetMaxW = ''
      this.ruledSetMaxH = ''
      this.ruledSetMaxD = ''
      this.axisType = 0
      this.ruledAxisType = AXIS_TYPE.UNDEFINED
      this.ruledSpaceList = []
      this.validateErrorMessages = {}
      this.validateCustomErrorMessages = {}
    },
    /** 得意先選択を初期化 */
    resetBusiness: function () {
      if (this.isEdit && this.fileData && Object.keys(this.fileData).length > 0) {
        this.fileData.planDataModel.planBusinessId = ''
      } else {
        this.businessId = ''
      }
      this.setSelectedBusiness()
    },
    setSelectedBusiness: function () {
      if (this.isEdit && this.fileData && Object.keys(this.fileData).length > 0) {
        this.selectedBusiness = this.businessList.filter(business => business.businessId === this.fileData.planDataModel.planBusinessId)[0]
      } else {
        this.selectedBusiness = this.businessList.filter(business => business.businessId === this.businessId)[0]
      }
    },
    /** 得意先選択を変更したら納品先の住所に反映させる */
    changeBusiness: function () {
      let notEntered = true
      const forms = Array.prototype.slice.call(document.getElementsByClassName('deli'))
      forms.forEach(form => {
        if (Object.keys(form.value).length > 0) notEntered = false
      })
      if (this.isEdit && this.fileData && Object.keys(this.fileData).length > 0) {
        let business = this.businessList.filter(business => business.businessId === this.fileData.planDataModel.planBusinessId)[0]
        this.selectedBusiness = business
        // 入力項目があるときは反映しない
        if (!notEntered) return
        this.fileData.planDataModel.planDeliveryName = business !== undefined && business !== null ? business.businessName : ''
        this.fileData.planDataModel.planDeliveryCountry = business !== undefined && business !== null ? business.businessCountry : ''
        this.fileData.planDataModel.planDeliveryPostcd = business !== undefined && business !== null ? business.businessPostcd : ''
        this.fileData.planDataModel.planDeliveryState = business !== undefined && business !== null ? business.businessState : ''
        this.fileData.planDataModel.planDeliveryCity = business !== undefined && business !== null ? business.businessCity : ''
        this.fileData.planDataModel.planDeliveryStreet = business !== undefined && business !== null ? business.businessStreet : ''
        this.fileData.planDataModel.planDeliveryBuilding = business !== undefined && business !== null ? business.businessBuilding : ''
        this.fileData.planDataModel.planDeliveryFloor = business !== undefined && business !== null ? business.businessFloor : ''
        this.fileData.planDataModel.planDeliveryTel = business !== undefined && business !== null ? business.businessTel : ''
        this.fileData.planDataModel.planDeliveryFax = business !== undefined && business !== null ? business.businessFax : ''
        this.fileData.planDataModel.planDeliverryLastName = business !== undefined && business !== null ? business.businessPersonLastName1 : ''
        this.fileData.planDataModel.planDeliverryFirstName = business !== undefined && business !== null ? business.businessPersonFirstName1 : ''
        this.fileData.planDataModel.planDeliverryLastNameKana = business !== undefined && business !== null ? business.businessPersonLastNameKana1 : ''
        this.fileData.planDataModel.planDeliverryFirstNameKana = business !== undefined && business !== null ? business.businessPersonFirstNameKana1 : ''
      } else {
        let business = this.businessList.filter(business => business.businessId === this.businessId)[0]
        this.selectedBusiness = business
        // 入力項目があるときは反映しない
        if (!notEntered) return
        this.planDeliveryName = business !== undefined && business !== null ? business.businessName : ''
        this.planDeliveryCountry = business !== undefined && business !== null ? business.businessCountry : ''
        this.planDeliveryPostcd = business !== undefined && business !== null ? business.businessPostcd : ''
        this.planDeliveryState = business !== undefined && business !== null ? business.businessState : ''
        this.planDeliveryCity = business !== undefined && business !== null ? business.businessCity : ''
        this.planDeliveryStreet = business !== undefined && business !== null ? business.businessStreet : ''
        this.planDeliveryBuilding = business !== undefined && business !== null ? business.businessBuilding : ''
        this.planDeliveryFloor = business !== undefined && business !== null ? business.businessFloor : ''
        this.planDeliveryTel = business !== undefined && business !== null ? business.businessTel : ''
        this.planDeliveryFax = business !== undefined && business !== null ? business.businessFax : ''
        this.planDeliveryLastName = business !== undefined && business !== null ? business.businessPersonLastName1 : ''
        this.planDeliveryFirstName = business !== undefined && business !== null ? business.businessPersonFirstName1 : ''
        this.planDeliveryLastNameKana = business !== undefined && business !== null ? business.businessPersonLastNameKana1 : ''
        this.planDeliveryFirstNameKana = business !== undefined && business !== null ? business.businessPersonFirstNameKana1 : ''
      }
    },
    /** カラーマテリアルモーダルの表示（デフォルト） */
    showCMListModalFromDef: function (colorStyleDefault) {
      this.$refs.ColorMaterialListModalRef.showModal(
        colorStyleDefault,
        this.colorMaterialList.filter(e => e.colorMaterialType === this.colorStyleTypeList[0]),
        true,
        0)
    },
    /** カラーマテリアルモーダルの表示（グループ） */
    showCMListModalFromGrp: function (colorStyleGrp, colorStyleType, num) {
      this.$refs.ColorMaterialListModalRef.showModal(
        colorStyleGrp,
        this.colorMaterialList.filter(e => e.colorMaterialType === colorStyleType),
        false,
        num)
    },
    /** デフォルトのカラースタイルの変更（デフォルト） */
    changeColorStyleDefault: function (colorStyleDefault) {
      const customFlg = this.colorMaterialList.find(c => c.colorMaterialId === colorStyleDefault).colorMaterialCustomFlg
      if (this.isEdit) {
        this.fileData.colorStyleDataModelList[0].colorStyleDefault = colorStyleDefault
        if (!customFlg) {
          this.fileData.colorStyleDataModelList[0].colorStyleDefaultColor = null
        }
      } else {
        this.colorStyleDefault = colorStyleDefault
        if (!customFlg) {
          this.colorStyleDefaultColor = null
        }
      }
    },
    /** デフォルトのカラースタイルの変更（グループ） */
    changeColorStyleGrp: function (colorStyleGrp, num) {
      const customFlg = this.colorMaterialList.find(c => c.colorMaterialId === colorStyleGrp).colorMaterialCustomFlg
      if (this.isEdit) {
        this.uColorStyleGrp[num] = colorStyleGrp
        if (!customFlg) {
          this.uColorStyleGrpColor[num] = null
        }
      } else {
        this.colorStyleGrp[num] = colorStyleGrp
        if (!customFlg) {
          this.colorStyleGrpColor[num] = null
        }
      }
    },
    /** カラー画像の表示（デフォルト） */
    showCustomListModalFromDef: function (colorStyleDefaultColor, colorStyleDefault) {
      this.$refs.CustomColorListModalRef.showModal(
        colorStyleDefault,
        colorStyleDefaultColor,
        this.colorMaterialList.filter(e => e.colorMaterialType === this.colorStyleTypeList[0]),
        true,
        0)
    },
    /** カラー画像の表示（グループ） */
    showCustomListModalFromGrp: function (colorStyleGrpColor, colorStyleGrp, colorStyleType, num) {
      this.$refs.CustomColorListModalRef.showModal(
        colorStyleGrp,
        colorStyleGrpColor,
        this.colorMaterialList.filter(e => e.colorMaterialType === colorStyleType),
        false,
        num)
    },
    /** カラー画像の変更（デフォルト） */
    changeColorIdDefault: function (id) {
      if (this.isEdit) {
        this.fileData.colorStyleDataModelList[0].colorStyleDefaultColor = id
      } else {
        this.colorStyleDefaultColor = id
      }
    },
    /** カラー画像の変更（グループ） */
    changeColorIdGrp: function (id, num) {
      if (this.isEdit) {
        this.uColorStyleGrpColor[num] = id
      } else {
        this.colorStyleGrpColor[num] = id
      }
    },
    /** モーダル非表示 */
    onCancel: function (event) {
      this.modalDispIf = false
      if (this.isEdit && this.isSaveAs && !this.fileData.forCopy) {
        this.$emit('onSave')
      }
    },
    /** 表示するタブ一覧取得 */
    filterTabList: function () {
      if (this.isOrder) {
        return this.tabList.filter(function (element, index, array) {
          return [0, 1, 2].includes(index)
        })
      }
      if (this.isOnlyRegisterContentsData) {
        return this.tabList.filter(function (element, index, array) {
          return index === 6 && this.isSrvContentsData
        }.bind(this))
      }
      if (this.isSetPlan) {
        return this.tabList.filter(function (element, index, array) {
          return [0, 5].includes(index) || (index === 6 && this.isSrvContentsData)
        }.bind(this))
      }
      if (this.isCombine || this.isSetFix) {
        return this.tabList.filter(function (element, index, array) {
          return index === 0 || (index === 6 && this.isSrvContentsData)
        }.bind(this))
      }
      return this.tabList.filter(function (element, index, array) {
        return [0, 1, 2, 3, 4].includes(index) || (index === 6 && this.isSrvContentsData)
      }.bind(this))
    },
    /** カテゴリ一覧取得 */
    getCategoryList: function () {
      axios.get(API_URL.PLANNING + '/category'
      ).then(response => {
        this.categoryList = response.data.data
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** カラー素材一覧取得 */
    getColorMaterialList: function () {
      axios.get(API_URL.PLANNING + '/color-material'
      ).then(response => {
        this.colorMaterialList = response.data.data
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** カラースタイル設定取得 */
    getColorStyleConf: function (id) {
      axios.get(API_URL.PLANNING + '/color-style-conf/' + id
      ).then(response => {
        this.colorStyleConf = response.data.data
        // リスト表示しやすいようにデータを整形する
        this.colorStyleNameList = {
          0: this.colorStyleConf.colorStyleConfigDefaultComment,
          1: this.colorStyleConf.colorStyleConfigGroup1Comment,
          2: this.colorStyleConf.colorStyleConfigGroup2Comment,
          3: this.colorStyleConf.colorStyleConfigGroup3Comment,
          4: this.colorStyleConf.colorStyleConfigGroup4Comment,
          5: this.colorStyleConf.colorStyleConfigGroup5Comment,
          6: this.colorStyleConf.colorStyleConfigGroup6Comment,
          7: this.colorStyleConf.colorStyleConfigGroup7Comment,
          8: this.colorStyleConf.colorStyleConfigGroup8Comment,
          9: this.colorStyleConf.colorStyleConfigGroup9Comment,
          10: this.colorStyleConf.colorStyleConfigGroup10Comment
        }
        // プルダウン表示しやすいようにデータを整形する
        this.colorStyleTypeList = {
          0: this.colorStyleConf.colorStyleConfigDefaultType,
          1: this.colorStyleConf.colorStyleConfigGroup1Type,
          2: this.colorStyleConf.colorStyleConfigGroup2Type,
          3: this.colorStyleConf.colorStyleConfigGroup3Type,
          4: this.colorStyleConf.colorStyleConfigGroup4Type,
          5: this.colorStyleConf.colorStyleConfigGroup5Type,
          6: this.colorStyleConf.colorStyleConfigGroup6Type,
          7: this.colorStyleConf.colorStyleConfigGroup7Type,
          8: this.colorStyleConf.colorStyleConfigGroup8Type,
          9: this.colorStyleConf.colorStyleConfigGroup9Type,
          10: this.colorStyleConf.colorStyleConfigGroup10Type
        }
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** 掛け率一覧取得 */
    getProfitList: function () {
      console.log('call getProfitList')
      axios.get(API_URL.PLANNING + '/profit'
      ).then(response => {
        this.profitList = response.data.data
      }).catch(error => {
        Api.handleError(error)
      })
    },
    getColorMaterial: function (num, editFlg) {
      if (editFlg) {
        return this.colorMaterialList.find(c => c.colorMaterialId === this.uColorStyleGrp[num])
      } else {
        return this.colorMaterialList.find(c => c.colorMaterialId === this.colorStyleGrp[num])
      }
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    /** キャンバス内キーボード制御 */
    operateEventListener: function () {
      if (this.modalDispIf && this.modalDispShow) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    },
    /** 設置場所をコードから変換 */
    convertInstLocation: function (instLocation) {
      switch (instLocation) {
        case 1:
          return '集合住宅(1階)'
        case 2:
          return '集合住宅(2階以上)'
        case 3:
          return '一戸建て住宅(1階)'
        case 4:
          return '一戸建て住宅(2階以上)'
        case 5:
          return 'その他'
        default:
          console.log('想定外のコードです')
          return ''
      }
    },
    /** エレベーターの有無を変換 */
    convertElevatorFlg: function (elevatorFlg) {
      if (elevatorFlg) {
        return '有'
      } else {
        return '無'
      }
    },
    convertSketchName: function (userLastName, userFirstName) {
      if (userLastName !== null && userFirstName !== null) {
        return userLastName + userFirstName
      } else if (userLastName !== null && userFirstName === null) {
        return userLastName
      } else if (userLastName === null && userFirstName !== null) {
        return userFirstName
      }
      return ''
    }
  },
  created: function () {
    this.getCategoryList()
    this.getColorMaterialList()
    this.getMaxFileSize()
    this.getProfitList()
    this.$store.dispatch('loadBusinessList')
  }
}
</script>
<style lang="scss" scoped>
select{
  width: 267px;
}
.data-area {
  min-height: 200px;
  max-height: 645px;
  overflow: auto;
  margin: 20px auto;
  -webkit-box-shadow: 0 0 10px rgba(102, 102, 102, 0.1);
  box-shadow: 0 0 10px rgba(102, 102, 102, 0.1);
  .tab-area{
    display: inline-flex;
    width:100%;
    .tab-item {
      width:100%;
      line-height: 30px;
      display:block;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
      background: #d9d9d9;
      border-bottom: 3px solid #ddd;
    }
    .active {
    background: #FFF;
    border-top: 3px solid #ff4500;
    border-bottom: none;
    }
    li:hover{
      cursor: pointer;
      opacity: 0.75;
    }
  }
  .contents{
    margin: 20px auto;
    .tab-detail{
      text-align: center;
      min-height: 550px;
      padding-bottom: 20px;
      .tab-detail-disable {
        background: #dddddd;
        opacity: 0.5;
        pointer-events: none;
      }
      .message_area{
        width: 480px;
        .custom_message {
          padding: 15px;
          font-size: 90%;
          line-height: 1.5;
          float: left;
        }
      }
    }
    .tab-detail-color-style{
        text-align: left;
        min-height: 550px;
        padding-bottom: 20px;
        padding-left: 20px;
        .label-color-style{
          min-width: 195px;
          display: inline-block;
          text-align: center;
        }
        .div-color-style{
          width: 247px;
          display: inline-block;
        }
        .div-custom{
          width: 70px;
        }
    }
    li {
      margin: 10px auto;
    }
    .base-info {
      .label {
        min-width: 170px;
      }
      .save-check {
        min-width: 440px;
        margin: 5px 0;
      }
    }
    .label{
      min-width: 185px;
      display: inline-block;
      text-align: left;
    }
    .label-radio{
      @extend .label;
      min-width: 199px;
    }
    .select-time{
      width: 450px;
      text-align: left;
      margin: auto;
    }
    .bs-radio{
      width: 181px;
    }
    div{
      width: 246px;
      display: inline-block;
      padding: 10px;
      text-align: left;
    }
    // .div-radio{ // del 戻す 20230726
    //   width: 266px;
    //   display: inline-block;
    //   padding: 0px;
    //   text-align: left;
    // }
    .sub-title {
      text-align: center;
      margin-bottom: 10px;
    }
    .size-input {
      input {
        width: 70px;
        margin: 0 20px;
      }
      div {
        width: 96px;
        padding: 5px 10px 0px 28px;
        text-align: center;
        display: inline-block;
      }
      .size-text {
        width: 20px;
        padding: 0px;
      }
    }
    .plan-data2{
      width: 750px;
      padding: 0px;
      .input-area {
        width: 340px;
        float: left;
        padding: 10px;
        input {
          width: 90px;
          text-align: right;
        }
      }
      .left {
        padding: 40px 20px;
        .bs-input-price{ // add DCD-464 20230912
          padding: 7px 10px;
        }
      }
      .right {
          width: 300px;
          padding: 12px;
          margin: 5px 0;
          font-weight: bold;
          border: solid 2px #888888;
      }
    }
    .ratio-area {
      width: 80%;
      height: 300px;
      position: relative;
      .ratio-input-area {
        display: flex;
        width: 160px;
        padding: 10px 20px;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        input {
          width: 50px;
        }
        ul {
          input[type="checkbox"] {
            margin: 10px
          }
        }
      }
      .top-text {
        position: absolute;
        width: auto;
        left: 20%;
        top: 0px;
        margin: 4px;
      }
      .bottom-text {
        position: absolute;
        width: auto;
        left: 20%;
        top: 290px;
        margin: 4px;
      }
      .left-text {
        position: absolute;
        width: auto;
        left: 20%;
        top: calc(70% - 10px);
        margin: 4px;
      }
      .right-text {
        position: absolute;
        width: auto;
        left: calc(20% + 290px);
        top: calc(70% - 10px);
        margin: 4px;
      }
      .vertical-text {
        position: absolute;
        width: auto;
        left: calc(20% - 10px);
        top: 138px;
      }
      .horizontal-text {
        position: absolute;
        width: auto;
        left: 50%;
        top: calc(70% + 10px);
        transform: translateX(-50%);
      }
      .arrow-vertical {
        display: inline-block;
        position: relative;
        width: 2px;
        height: 250px;
        padding: 0;
        background-color:black;
        margin: 30px 20px;
        position: absolute;
        left: 20%;
      }
      .arrow-vertical:before {
        content: '';
        position: absolute;
        display: inline-block;
        top: -9px;
        right: -7px;
        border: 8px solid transparent;
        border-bottom: 8px solid black;
      }
      .arrow-vertical:after {
        content: '';
        position: absolute;
        display: inline-block;
        bottom: -9px;
        right: -7px;
        border: 8px solid transparent;
        border-top: 8px solid black;
      }
      .arrow-horizontal {
        position:relative;
        width: 250px;
        height: 2px;
        padding: 0;
        background-color:black;
        margin-top: 9px;
        position: absolute;
        left: 50%;
        top: 70%;
        transform: translateX(-50%);
      }
      .arrow-horizontal:before {
        content: '';
        position: absolute;
        display: inline-block;
        top: -7px;
        left: -9px;
        border: 8px solid transparent;
        border-right:8px solid black;
      }
      .arrow-horizontal:after {
        content: '';
        position: absolute;
        display: inline-block;
        top: -7px;
        right: -9px;
        border: 8px solid transparent;
        border-left: 8px solid black;
      }
    }
    .horizontal {
      li{
        float: left;
        input {
          margin: 0 5px;
        }
      }
      .ratio-input-area {
        display: inline-block;
        width: fit-content;
        div {
          width: 30px;
        }
        ul {
          display: flex;
          input[type="checkbox"] {
            margin: 9px 18px
          }
        }
      }
    }
    input[type="file"] {
      display:none;
    }
    .contents_data_img {
      vertical-align: middle;
    }
  }
}
.new-modal{
  max-height: 100%;
  max-width: 1200px;
  min-width: 840px;
  padding-left: 40px;
  padding-right: 40px;
}
input.sm{
  width: 60px
}
.bs-input{
  width:240px;
}
.input_div {
  margin-left: 175px;
}
.half{
  width:106px;
}
.desp{
  position: relative;
  top: -185px;
}
.error_message{
  margin: 5px auto;
  text-align: left;
  padding-left: 123px;
}
.error_ds{
  position: relative;
  top: -178px;
}
textarea{
  resize: none;
}
// .plan_data2{
//   input {
//     width: 90px;
//     text-align: right;
//   }
//   li {
//     .process_cost_min{
//       margin-left: 20px;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/FileModal.vue